import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'

//中文
export default {
  ...zhLocale,
  ...zhCN,

  base: {
    error: {
      400: '请求数据出错，请稍后再试！',
      401: '授权异常或者登录已过期，请重新登录！',
      404: '未找到相关数据！',
      500: '服务内部错误，请联系管理员！',
      503: '服务不可用，请稍后再试！'
    },
    title: '衡电云平台',
    prompt_title: '温馨提示',
    develop: '开发中...',
    success: '操作成功！',
    more: '更多',
    upload: {
      error: '上传失败！'
    },
    zh: '中文',
    en: '英文'
  },

  login: {
    account: '账号登录',
    username_placeholder: '请输入登录邮箱',
    username_label: '电子邮箱',
    username_empty: '请输入登录邮箱',
    username_type: '请输入正确的邮箱地址',
    password_label: '登录密码',
    password_placeholder: '请输入登录密码',
    password_empty: '请输入登录密码',
    login_in: '立即登录',
    code: '验证码登录',
    code_label: '验证码',
    code_empty: '请输入验证码',
    code_placeholder: '请输入验证码',
    msg_empty: '发送验证码',
    msg_sending: '{value}秒后重试',
    clause_text: '阅读并同意',
    clause_title: '《隐私权政策》',
    remember: '记住密码',
    forgot: '忘记密码？',
    register_prefix: '没有账号？',
    register: '去注册',
    wechat: '微信登录',
    qq: 'QQ登录',
    facebook: 'Facebook登录',
    twitter: 'Twitter登录',
    password_old: '旧密码',
    password_old_placeholder: '请输入旧密码',
    password_old_empty: '请输入旧密码',
    password_new: '新密码',
    password_new_placeholder: '请输入新密码',
    password_new_empty: '请输入新密码',
    password_confirm: '确认密码',
    password_confirm_placeholder: '请输入确认密码',
    password_confirm_empty: '请输入确认密码',
    password_confirm_error: '确认密码与新密码不匹配',
    login_forgot: '重置密码',
    zipCode_label: '邮政编码',
    zipCode_empty: '请输入邮政编码',
    zipCode_placeholder: '请输入邮政编码',
    phone_label: '电话号码',
    phone_placeholder: '请输入电话号码',
    company_label: '公司名称',
    company_placeholder: '请输入公司名称',
    company_empty:'请输入公司名称',
    licence_label: '执照号码',
    licence_placeholder: '请输入营业执照号码',
    licence_empty: '请输入营业执照号码',
    address_placeholder: '请输入营业地址',
    address_empty: '请输入营业地址',
    invite_label: '邀请码',
    invite_placeholder: '请输入邀请码',
    invite_empty: '请输入邀请码',
    continents_label: '大洲',
    continents_placeholder: '请选择大洲',
    continents_empty: '请选择大洲',
    country_label: '国家',
    country_placeholder: '请选择国家',
    country_empty: '请选择国家',
    province_label: '省份',
    province_placeholder: '请输入省份',
    province_empty: '请输入省份',
    city_label: '城市',
    city_placeholder: '请输入城市',
    city_empty: '请输入城市',
    region_label: '地区',
    region_placeholder: '请输入地区',
    region_empty: '请输入地区',
    street_label: '街道',
    street_placeholder: '请输入街道',
    street_empty: '请输入街道',
    detail_label: '详细地址(中文)',
    detail_placeholder: '请输入中文详细地址',
    detail_empty: '请输入详细地址',
    pcrDetail_label: '省/州/城市(中文)',
    pcrDetail_placeholder: '请输入中文省/州/城市',
    pcrDetail_empty: '请输入省/州/城市',
    enPcrDetail_label: '省/州/城市(英文)',
    enPcrDetail_placeholder: '请输入英文省/州/城市',
    enDetail_label: '详细地址(英文)',
    enDetail_placeholder: '请输入英文详细地址',
    customerCode_label: '客户代码',
    customerCode_placeholder: '请输入客户代码'
  },

  policies: {
    back: '返回登录',
    title: '隐私权政策说明',
    zh_title: '中文内容',
    us_title: '英文内容',
    save: '保存'
  },

  forgot:{
    back: '返回',
    title: '找回密码',
    success: '重置密码成功！'
  },

  register: {
    back: '返回登录',
    step1_title: '类型选择',
    step2_title: '基本信息',
    step3_title: '公司信息',
    step4_title: '注册成功',
    step1_user1: '经销商注册',
    step1_user2: '安装商注册',
    step1_user3: '电站业主注册',
    btn_next: '下一步',
    btn_pre: '返回上一步',
    btn_register: '立即注册',
    company_title: '新公司注册',
    invite_title: '邀请码注册',
    success: '恭喜您，注册成功！',
    success_btn: '立即登录',
    password_confirm_error: '确认密码与登录密码不匹配'
  },

  work: {
    menu_expand: '展开菜单',
    menu_collapse: '收起菜单',
    user_info: '修改资料',
    user_logout: '退出登录',
    logout_prompt: '您确定要退出登录吗？'
  },

  info: {
    title: '个人资料',
    tabs: {
      info: '基本信息',
      company: '企业信息',
      security: '安全设置',
      agreement: '服务协议'
    },
    info: {
      username: '账号/邮箱：',
      mailbox: '告警推送邮箱：',
      mailbox_placeholder: '请选择告警推送等级',
      mailbox_empty: '关闭',
      zipCode: '邮编：',
      phone: '手机号：',
      btn: '立即修改'
    },
    company: {
      status: '状态：',
      status_0: '审核通过',
      status_1: '待审核',
      status_2: '审核未通过',
      code: '邀请码：',
      copy: '复制',
      copy_success: '复制成功！',
      copy_error: '复制失败',
      name: '公司名称：',
      licence: '营业执照：',
      address: '经营地址：',
      continents: '大洲/国家：',
      region: '地区：',
      street: '街道：',
      detail: '详细地址：',
      pcrDetail: '省/州/城市：',
      approveReason: '审核原因：',
      editBtn: '立即修改'
    },
    security: {
      editbtn: '修改',
      password: '密码设置：',
      password_describe: '已设置账户的密码',
      password_title: '修改密码',
      username: '更改账号：',
      username_describe: '已绑定的邮箱',
      username_title: '更改账号',
      bind: '立即绑定',
      unbind: '取消绑定',
      wechat: '绑定微信：',
      wechat_describe: '已绑定的微信',
      qq: '绑定QQ：',
      qq_describe: '已绑定的QQ',
      facebook: '绑定Facebook：',
      facebook_describe: '已绑定的Facebook',
      twitter: '绑定Twitter：',
      twitter_describe: '已绑定的Twitter',
      cancel: '注销账号：',
      cancel_describe: '注销当前账号，抹除全部数据',
      cancelBtn: '注销',
      username_label: '账号/邮箱',
      code_label: '验证码',
      cancel_prompt: '注销帐号后您的身份信息，帐号信息，所有使用记录，包括不限于历史记录，报警记录，交易记录等将被清空且无法找回, 是否继续?'
    }
  },

  dialog:{
    define: '确认',
    cancel: '取消'
  },

  table: {
    seq: '序号',
    refresh: '刷新',
    add: '添加',
    edit: '编辑',
    delete: '删除',
    delete_prompt: '确定要删除当前数据吗？',
    select_empty: '请选择数据！',
    subset_add: '添加子级',
    status: '状态',
    status_0: '正常',
    status_1: '删除',
    status_2: '停用',
    status_placeholder: '请选择状态',
    sortNum: '排序码',
    sortNum_placeholder: '请输入排序码',
    remark: '备注',
    remark_placeholder: '请输入备注',
    createTime: '创建时间',
    updateTime: '更新时间',
    action: '操作',
    query: '查询',
    reset: '重置',
    detail: '详情',
    input_placeholder: '请输入',
    export: '导出'
  },

  menu: {
    zhName: '中文名称',
    zhName_placeholder: '请输入中文名称',
    zhName_empty: '请输入中文名称',
    usName: '英文名称',
    usName_placeholder: '请输入英文名称',
    usName_empty: '请输入英文名称',
    type: '层级',
    perms: '权限',
    perms_placeholder: '请输入权限标识',
    component: '网页地址',
    component_placeholder: '请输入网页地址',
    detail: {
      title: '菜单维护'
    }
  },

  role: {
    left_title: '所属角色',
    right_title: '包含权限',
    name: '中文名称',
    name_empty: '请输入角色中文名称',
    name_placeholder: '请输入角色中文名称',
    enName: '英文名称',
    enName_empty: '请输入角色英文名称',
    enName_placeholder: '请输入角色英文名称',
    code: '角色编码',
    code_empty: '请输入角色编码',
    code_placeholder: '请输入角色编码',
    detail: {
      title: '角色维护'
    },
    save: '保存'
  },

  user: {
    username: '邮箱',
    username_placeholder: '请输入邮箱',
    country: '国家',
    country_placeholder: '请选择国家',
    role: '角色',
    role_placeholder: '请选择角色',
    phone: '电话',
    zipCode: '邮政编码',
    company: '公司',
    company_title: '公司详细信息',
    companys: {
      name: '公司名称',
      status: '状态',
      licence: '营业执照',
      country: '国家',
      pcrDetail: '省/州/城市',
      detail: '详细地址',
      approveReason: '审核原因'
    },
    enable: '启用',
    stop: '停用',
    delete: '删除',
    add_title: '添加用户',
    companyId: '公司',
    company_empty: '请选择所属公司',
    companyId_placeholder: '请选择所属公司',
    lastLoginDate: '最近登录时间',
    deleteInfo: '确定要删除【{user}】用户？',
    dealer: '关联经销商'
  },

  company: {
    name: '公司名称',
    name_placeholder: '请输入公司名称',
    approveStatus: '审核状态',
    approveStatus_placeholder: '请选择审核状态',
    approveStatus_0: '通过',
    approveStatus_1: '待审核',
    approveStatus_2: '未通过',
    licence: '营业执照',
    licence_placeholder: '请输入营业执照',
    continents: '大洲',
    country: '国家',
    country_placeholder: '请选择国家',
    pcrDetail: '省/州/城市',
    detail: '详细地址',
    approveReason: '审核原因',
    approveReason_placeholder: '请输入审核原因',
    examine: '审核',
    examine_title: '审核',
    audit: '待审核',
    confirm_button: '通过',
    cancel_button: '不通过',
    status_prompt: '该公司信息是否通过审核？',
    user_btn: '用户',
    user_title: '用户列表',
    details: {
      title: '公司详情'
    }
  },

  warn: {
    names: '名称',
    names_placeholder: '请输入名称',
    name: '中文名称',
    name_empty: '请输入告警中文名称',
    name_placeholder: '请输入告警中文名称',
    enName: '英文名称',
    enName_empty: '请输入告警英文名称',
    enName_placeholder: '请输入告警英文名称',
    code: '告警码',
    code_empty: '请输入告警码',
    code_placeholder: '请输入告警码',
    deviceType: '设备类型',
    deviceType_empty: '请选择设备类型',
    deviceType_placeholder: '请选择设备类型',
    grade: '告警等级',
    grade_placeholder: '请选择告警等级',
    grade_empty: '请选择告警等级',
    grade_0: '告警',
    grade_1: '故障',
    reason: '告警原因',
    reason_placeholder: '请输入告警原因',
    advice: '操作建议',
    advice_placeholder: '请输入操作建议',
    detail: {
      title: '告警维护'
    },
    info: {
      title: '告警详情',
      total: '告警总数',
      unhandle: '未处理数',
      handle: '已处理数',
      define: '已处理',
      download: '去下载',
      export: '导出'
    }
  },

  dic: {
    name: '中文名称',
    name_empty: '请输入中文名称',
    name_placeholder: '请输入中文名称',
    usName: '英文名称',
    usName_empty: '请输入英文名称',
    usName_placeholder: '请输入英文名称',
    code: '取值码',
    code_placeholder: '请输入取值码',
    value: '值',
    value_placeholder: '请输入值',
    detail: {
      title: '字典维护'
    }
  },

  product: {
    name: '产品名称',
    name_empty: '请输入产品名称',
    name_placeholder: '请输入产品名称',
    deviceType: '设备类型',
    deviceType_empty: '请选择设备类型',
    deviceType_placeholder: '请选择设备类型',
    detail: {
      title: '产品维护'
    }
  },

  guide: {
    v2g: '充放电桩',
    switchbox: '智能配电箱',
    inverter: '逆变器',
    collector: '采集器',
    battery: '电池',
    solar: '太阳能板',
    charge: '充电桩',
    count: {
      total: '总数',
      online: '在线',
      warn: '告警',
      fault: '故障',
      offline: '离线',
      pending: '待上线'
    },
    station: {
      list_day_buy: '总计当日买电量',
      list_day_sell: '总计当日售电量',
      list_month_buy: '总计当月买电量',
      list_month_sell: '总计当月售电量',
      one_day_buy: '电站当日买电量',
      one_day_sell: '电站当日售电量',
      one_month_buy: '电站当月买电量',
      one_month_sell: '电站当月售电量',
      weather: {
        week: {
          0: '星期天',
          1: '星期一',
          2: '星期二',
          3: '星期三',
          4: '星期四',
          5: '星期五',
          6: '星期六'
        },
        time: '更新于'
      },
      count: {
        day: '日',
        month: '月',
        all: '总',
        all_generation_power: '总发电量',
        all_use_power: '总用电量',
        self_generation_sale: '自发卖电金额',
        self_generation_use: '自发用电金额',
        buy_amount: '买电金额',
        sell_amount: '卖电金额',
        payable_amount: '应缴总金额',
        paid_amount: '实缴总金额',
        save_amount: '节约总金额',
        coal_savings: '煤炭节约量',
        equivalent_green_plant: '等效绿植',
        co2_reduction: 'Co2减排量'
      },
      energy: {
        pv_title: 'PV',
        pv_content: '当日发电：',
        battery_title: '电池',
        battery_content: '当日充/放电：',
        grid_title: '电网',
        grid_content: '当日买/卖电：',
        charge_title: '充电桩',
        charge_content: '当日用电：',
        load_title: '负载',
        load_content: '当日用电：',
        ups_title: 'UPS',
        ups_content: '当日用电：',
        eps_title: '备用电源',
        power_title: '电源'
      },
      power: {
        pv: 'PV功率',
        grid: '电网功率',
        battery: '电池功率',
        charge: '充电桩功率',
        load: '负载功率'
      },
      list: {
        title: '电站列表',
        add: '添加电站',
        table: {
          name: '电站名称',
          name_placeholder: '请输入电站名称',
          owner: '业主',
          owner_placeholder: '请输入业主',
          dealer: '经销商',
          dealer_placeholder: '请输入经销商',
          installer: '安装商',
          installer_placeholder: '请输入安装商',
          id: 'ID',
          id_placeholder: '请输入ID',
          sn: 'SN',
          sn_placeholder: '请输入SN',
          country: '国家',
          country_placeholder: '请选择国家',
          postCode: '邮政编码',
          postCode_placeholder: '请输入邮政编码',
          createTime: '创建时间',
          createTime_range: '至',
          createTime_start: '开始时间',
          createTime_end: '结束时间',
          firstOnTime: '首次在线时间',
          firstOnTime_range: '至',
          firstOnTime_start: '开始时间',
          firstOnTime_end: '结束时间'
        }
      },
      map: {
        title: '电站地图'
      },
      add: {
        title: '添加电站',
        step1_title: '基本信息',
        step2_title: '电价设置',
        name: '电站名称',
        name_empty: '请输入电站名称',
        name_placeholder: '请输入电站名称',
        siteType: '电站类型',
        siteType_empty: '请选择电站类型',
        siteType_placeholder: '请选择电站类型',
        volume: '预计总容量',
        volume_placeholder: '请输入预计总容量',
        zipCode: '邮政编码',
        zipCode_placeholder: '请输入邮政编码',
        gridType: '并网类型',
        gridType_placeholder: '请选择并网类型',
        gmt: '时区',
        gmt_placeholder: '请选择时区',
        gridTime: '并网时间',
        gridTime_placeholder: '请选择并网时间',
        address: '所在地址',
        address_placeholder: '请选择所在地址',
        detail: '详细地址',
        detail_placeholder: '请输入详细地址',
        next_btn: '下一步',
        pre_btn: '上一步',
        price_company: '电力公司',
        price_company_placeholder: '请输入电力公司名称',
        price_day_range: '至',
        price_day_start: '开始日期',
        price_day_end: '结束日期',
        price_time_range: '至',
        price_time_start: '开始时间',
        price_time_end: '结束时间',
        price_price: '电价',
        price_work_title: '工作日电价：',
        price_nonwork_title: '非工作日电价：',
        cost: '投入成本',
        cost_placeholder: '请输入投入成本',
        date_error: '日期不能为空',
        time_error: '时间不能为空',
        price_error: '价格不能为空',
        date_repeat: '日期区间重复',
        time_repeat: '时间区间重复',
        time_continuous: '时间区间不连续',
        country_zh: '国家中文名称',
        country_en: '国家英文名称',
        country_zh_placeholder: '请输入国家中文名称',
        country_en_placeholder: '请输入国家英文名称',
        detail_zh: '详细地址中文',
        detail_en: '详细地址英文',
        detail_zh_placeholder: '请输入详细地址中文',
        detail_en_placeholder: '请输入详细地址英文',
        choose: '选择',
        x: '经度',
        x_placeholder: '请输入经度',
        y: '纬度',
        y_placeholder: '请输入纬度'
      },
      address: {
        title: '所在地址选择',
        select: '选中地址：',
        prompt: '在地图上点击位置，即可选中地点',
        x: '经度',
        y: '维度',
        query: '经纬度查询'
      },
      detail: {
        base_title: '基本信息',
        base_add: '添加设备',
        base_name: '电站名称',
        base_siteType: '电站类型',
        base_volume: '预计总容量',
        base_status: '状态',
        base_owner: '业主',
        base_gmt: '时区',
        base_address: '地址',
        add: {
          title: '电站添加设备',
          sn: 'SN',
          sn_placeholder: '请输入SN',
          name: '设备名称',
          model: '设备型号',
          system_name: '系统名称：',
          system_name_placeholder: '请输入系统名称',
          installer_name: '安装商：',
          installer_name_placeholder: '请选择安装商',
          id_name: 'ID',
          id_name_placeholder: '请输入设备ID',
          concatType_name: '连接类型：',
          concatType_name_placeholder: '请选择连接类型',
          concatType_0: '单连',
          concatType_1: '并联',
          deviceIds: '请选择需要添加的设备',
          search: '选择',
          activeBind: '激活/绑定'
        },
        guide: {
          title: '概览',
          panel_battery_1: '充电',
          panel_battery_2: '放电',
          pv: 'PV',
          grid: '电网',
          battery: '电池',
          charge: '充电桩',
          load: '负载',
          soc: 'SOC',
          alternator: '发电机',
          buy: '买电量',
          sell: '卖电量',
          card_generate_power: '日发电量',
          card_usage_power: '日用电量',
          card_buy_power: '卖电收入',
          card_sell_power: '买电支出',
          count_time_placeholder: '请选择',
          count_date: '日',
          count_month: '月',
          count_year: '年',
          count_count: '总',
          download: '下载',
          start_time_range: '至',
          start_time_placeholder: '开始日期',
          end_time_placeholder: '结束日期',
          export_a: '电站'
        },
        setup: {
          title: '设置',
          power_alarm_min: '最低耗电报警',
          power_alarm_min_placeholder: '请输入最低耗电报警',
          power_alarm_max: '最高耗电报警',
          power_alarm_max_placeholder: '请输入最高耗电报警',
          power_alarm_prompt_placeholder: '请输入提示'
        },
        analysis: {
          title: '分析'
        },
        layout: {
          title: '布局',
          time_placeholder: '选择日期',
          play: '播放',
          pause: '停止',
          edit: '编辑布局',
          plus: '添加',
          delete: '删除',
          delete_prompt: '确定要删除选中组件吗？',
          edit1: '编辑',
          bind: '绑定',
          unbind: '解绑',
          back: '返回',
          save: '保存',
          data: {
            title: '添加组件组',
            row: '行数',
            column: '列数',
            direction: '方向',
            direction0: '纵向',
            direction1: '横向',
            dip: '倾角(°)',
            position: '方位角(°)',
            btn: '确定'
          },
          binding: {
            title: '绑定设备',
            search_placeholder: '请输入设备SN'
          }
        },
        infor: {
          title: '资料',
          save: '保存'
        },
        device: {
          title: '设备',
          name: '名称',
          main: '设置主从设备',
          masterOrSlave: '主从关系',
          masterOrSlave_0: '无',
          masterOrSlave_1: '主',
          masterOrSlave_2: '从',
          main_error: '没有设备信息可修改',
          main_master_error: '主设备只能有一台',
          out: '退出电站',
          out_prompt: '该设备确定要退出电站吗？',
          out_system_prompt: '确定要删除系统吗？',
          table_sn: 'SN',
          table_update_time: '更新时间',
          table_run_time: '投运时间',
          table_inverter_rated: '额定功率',
          table_inverter_real: '实时功率',
          table_inverter_day_quantity: '当日电量',
          table_inverter_count_quantity: '累计电量',
          table_collector_strength: '信号强度',
          table_battery_model: '型号'
        },
        warn: {
          title: '告警',
          table_grade: '等级',
          table_device: '告警设备',
          table_sn: '设备SN',
          table_content: '告警内容',
          table_code: '告警代码',
          table_time: '告警时间',
          table_handle: '处理方式'
        },
        energy: {
          title: '经济节能',
          dispatch: '智能调度',
          sell: '向电网卖电',
          buy: '向电网买电',
          save: '保存',
          sell_power: '最大卖电功率',
          buy_power: '最大买电功率',
          sell_power_placeholder: '请输入最大卖电功率',
          buy_power_placeholder: '请输入最大买电功率',
          tab_1: '费用',
          tab_2: '预测准确率',
          time_placeholder: '请选择',
          date: '日',
          month: '月',
          year: '年',
          count: '总'
        }
      }
    },
    device: {
      id: 'ID',
      sn: 'SN',
      mode: '按电站分类',
      dealer: '经销商',
      dealer_placeholder: '请选择经销商',
      installer: '安装商',
      station: '所属电站',
      version: '所属版本',
      country: '国家',
      zipCode: '邮编',
      remark: '备注',
      remark_placeholder: '请输入备注',
      advise: '使用建议',
      advise_placeholder: '请输入使用建议',
      restart: '重启',
      first_online_time: '首次在线时间',
      join_station_time: '加入电站时间',
      leave_station_time: '离开电站时间',
      offline_time: '离线时间',
      offline_num: '离线次数',
      duration: '在/离线时长',
      voltage: '电压(V)',
      soc: 'SOC(%)',
      upgrade_time: '升级时间',
      empty: '未选中设备，请在左侧列表中选择设备',
      add: {
        btn: '添加设备',
        title: '设备添加',
        value_placeholder: '请输入SN，多个使用英文逗号分隔',
        value_empty: '请输入SN'
      },
      crumb: '设备详情',
      filterSN: '输入SN或者设备ID进行过滤',
      more: '更多条件',
      battery: {
        count_day_kwh: '日用电量',
        count_month_kwh: '月用电量',
        count_day_charge: '日充电量',
        count_month_charge: '月充电量',
        model: '型号',
        sections: '电池节数',
        voltage_high: '最高电压',
        voltage_low: '最低电压',
        voltage_now: '当前电压',
        quantity_now: '当前电量',
        parallel_mode_unit_num: '并行模块单元数',
        battery: '电池',
        detail: {
          voltage: '电压',
          temperature: '温度',
          defaultCurrent: '电流',
          power: '功率',
          info: '主要信息',
          relay: '继电器',
          version: '版本号',
          bmsVersion: 'BMS版本',
          modulesNum: '模组数量',
          cellNum: '电芯串数',
          rateCapacity: '额定容量',
          soc: 'SOC',
          chargePower: '充电功率',
          dischargePower: '放电功率',
          incrChargeNum: '累计充电容量',
          strongImpact: '强冲状态',
          incrDischargeNum: '累计放电容量',
          allVoltage: '总压',
          systemVoltage: '系统电压',
          outputVoltage: '输出端口电压',
          totalIndividualVoltage: '单体电压总和',
          hv1: 'HV1',
          hv2: 'HV2',
          moduleNumber: '所在模组编号',
          IndividualDifference: '系统单体压差',
          reqChargeVoltage: '请求充电电压',
          commonIncrVoltage: '单体累计总压',
          avgCommonVoltage: '平均单体电压',
          maxCommonVoltage: '最高单体电压',
          minCommonVoltage: '最低单体电压',
          voltageDifferent: '压差',
          current: '电流',
          nowDefaultCurrent: '当前电流',
          reqChargeCurrent: '充电请求电流',
          reqDischargeCurrent: '放电请求电流',
          rateChargeCurrent: '额定充电电流',
          rateDischargeCurrent: '额定放电电流',
          maxChargingCurrent: '最大充电电流',
          maxDisChargingCurrent: '最大放电电流',
          effectTemperatureSensation: '有效温感数',
          maxCommonTemperature: '最大单体温度',
          minCommonTemperature: '最小单体温度',
          temperatureDifferent: '温差',
          commonTemperature: '单体温度{data}',
          heatElementTemperature: '加热片温度{data}',
          maxMonomerTemperature: '最高单体温度',
          minMonomerTemperature: '最低单体温度',
          relayTemperature: '继电器温度{data}',
          relayTableFunction: '功能',
          relayTableInstruct: '控制指令',
          relayTableState: '状态反馈',
          relayFunction: '继电器{data}功能',
          relayStatus: '继电器{data}状态',
          heatRelayStatus: '加热继电器{data}状态',
          heatRelayContactStatus: '加热继电器{data}触点状态',
          relay_1: '主正',
          relay_2: '主负',
          relay_3: '加热',
          relay_4: '预充',
          relay_5: '接线仓状态',
          module: '模组信息',
          balanced: '均衡状态',
          balanceVoltage: '均衡电压{data}',
          monomer: '单体信息',
          commonVoltage: '单体电压{data}',
          arguments: '参数设置',
          argumentsAll: '参数批量设置',
          debugging: '调试',
          debug: {
            title: '远程调试',
            input: '请输入指令',
            send: '发送',
            success: '建立链接成功',
            fail: '建立链接失败'
          },
          upgrade: '升级',
          export_name: '导出数据',
          export_range: '至',
          export_start: '开始时间',
          export_end: '结束时间',
          export_btn: '导出',
          export_a: '电池',
          chart: {
            time: '时',
            day: '日',
            month: '月',
            year: '年',
            total: '总',
            current: '电流',
            soc: 'SOC',
            temperature: '温度',
            voltage: '电压',
            voltages: '总电压',
            name: '电池统计图',
            title: '选择参数',
            type_1: '电池电压',
            type_2: '电池电流',
            type_3: '电池功率',
            type_4: '当日充电量',
            type_5: '累计充电量',
            type_6: '当日放电量',
            type_7: '累计放电量',
            type_8: 'BMS电池电压',
            type_9: 'BMS电池电流',
            type_10: '电池SOC',
            type_11: '电池SOH',
            type_12: '过放SOC',
            type_13: '强充SOC',
            type_14: '电池充电限流',
            type_15: '电池放电限流',
            max: '最多选择4个单位',
            export_emty: '请选择导出的数据'
          },
          relayFunctionValue: {
            'none': '',
            '0': '无',
            '1': '预充',
            '2': '制冷',
            '3': '加热',
            '4': '总正',
            '5': '总负',
            '6': '故障灯',
            '7': '运行灯',
            '8': '电源灯',
            '9': '充电',
            '10': '放电',
            '11': 'DCDC',
            '12': '自定义1',
            '13': '自定义2'
          },
          relayStatusValue: {
            'none': '',
            '0': '断开',
            '1': '闭合',
            '2': 'NA',
            '3': 'NA',
            '4': 'NA',
            '5': 'NA',
            '6': 'NA',
            '7': 'NA',
            '8': 'NA',
            '9': 'NA',
            '10': 'NA',
            '11': 'NA',
            '12': 'NA',
            '13': 'NA'
          },
          balanceVoltageValue: {
            'none': '',
            '0': '关',
            '1': '开'
          },
          mainPositiveRelay: {
            'none': '',
            '0': '断开',
            '1': '闭合',
            '2': 'NA',
            '3': 'NA',
            '4': 'NA',
            '5': 'NA',
            '6': 'NA',
            '7': 'NA',
            '8': 'NA',
            '9': 'NA',
            '10': 'NA',
            '11': 'NA',
            '12': 'NA',
            '13': 'NA'
          },
          strongImpactValue: {
            'none': '',
            '0': '非强冲',
            '1': '强冲'
          },
          alarm: {
            btn: '告警记录',
            title: '告警记录',
            name: '告警名称',
            name_placeholder: '请输入告警名称',
            code: '告警代码',
            code_placeholder: '请输入告警代码'
          }
        },
        modules: {
          voltage: '单体电压',
          voltageChart: '单体电压统计图',
          temperature: '温度{data}'
        }
      },
      inverter: {
        count_day_generation: '当日发电',
        count_day_use: '当日用电',
        count_day_buy: '当日买电',
        count_day_sale: '当日卖电',
        preview_real_time: '实时功率',
        preview_day: '日满发小时数',
        preview_alarm: '报警信息',
        preview_environment: '运行内部环境',
        preview_environment_max: '最高可承受105°C',
        preview_version: '版本号',
        preview_type: '设备类型',
        preview_plant: '采集器',
        preview_belongFactory: '逆变器厂商',
        belongFactory: {
          'none': '',
          1: 'H12',
          2: 'HX12',
          4: 'HH15'
        },
        detail: {
          system_title: '系统信息',
          system_code: '逆变器编码',
          system_state: '逆变器工作状态',
          system_rated_power: '逆变器额定功率',
          system_model: '逆变器设备型号',
          system_firm: '逆变器厂商',
          system_battery_firm: '电池厂商',
          system_meter_firm: '电表厂商',
          system_network_state: '联网状态',
          system_collector_sn: '采集器SN',
          version_title: '版本信息',
          version_dsp_main: '主DSP版本号',
          version_dsp_fit: '副DSP版本号',
          version_cpld: 'CPLD版本号',
          version_arm: 'ARM版本号',
          generation_title: '发电数据',
          generation_table1_title1: '直流',
          generation_table1_title2: '电压(V)',
          generation_table1_title3: '电流(A)',
          generation_table1_title4: '功率(W)',
          generation_table2_title1: '交流',
          generation_table2_title2: '电压(V)',
          generation_table2_title3: '电流(A)',
          generation_table2_title4: '功率(W)',
          generation_time: '发电时间',
          generation_day_quantity: '当天发电量',
          generation_all_quantity: '总发电量',
          generation_back_up_power: 'Back-Up总有功功率',
          generation_factor_power: '功率因数',
          generation_inverter_all_power: '逆变器总有功功率',
          generation_inverter_r_power: '逆变器R相有功功率',
          generation_inverter_s_power: '逆变器S相有功功率',
          generation_inverter_t_power: '逆变器T相有功功率',
          generation_normalize_power: '功率归一化',
          generation_day_hours: '当日满发小时',
          generation_dc_divergence: '直流离散率',
          generation_power: '发电功率',
          grid_title: '电网',
          grid_day_sell: '当日并网卖电量',
          grid_all_sell: '总并网卖电量',
          grid_day_buy: '当日并网购电量',
          grid_all_buy: '总并网购电量',
          grid_voltage_pbus: 'PBUS电压',
          grid_voltage_nbus: 'NBUS电压',
          grid_voltage_rs: 'RS电网线电压',
          grid_voltage_st: 'ST电网线电压',
          grid_voltage_tr: 'TR电网线电压',
          grid_voltage_r: 'R电网相电压',
          grid_voltage_s: 'S电网相电压',
          grid_voltage_t: 'T电网相电压',
          grid_current_r: 'R相并网电流',
          grid_current_s: 'S电网相电流',
          grid_current_t: 'T电网相电流',
          grid_power_all: '电网总有功功率',
          grid_power_r: '电网R相有功功率',
          grid_power_s: '电网S相有功功率',
          grid_power_t: '电网T相有功功率',
          grid_load_power_all: '电网总负载有功功率',
          grid_load_power_r: '电网R相负载有功功率',
          grid_load_power_s: '电网S相负载有功功率',
          grid_load_power_t: '电网T相负载有功功率',
          grid_rate: '电网频率',
          use_title: '用电',
          use_day_load: '负载当天耗电量',
          use_all_load: '负载总耗电量',
          meter_title: '电表数据',
          meter_comm_status: '电表通讯状态',
          meter_voltage_r: '电表R电压',
          meter_voltage_s: '电表S电压',
          meter_voltage_t: '电表T电压',
          meter_current_all: '电表总电流',
          meter_current_r: '电表R电流',
          meter_current_s: '电表S电流',
          meter_current_t: '电表T电流',
          meter_power_all: '电表总有功功率',
          meter_power_r: '电表R有功功率',
          meter_power_s: '电表S有功功率',
          meter_power_t: '电表T有功功率',
          battery_title: '电池数据',
          battery_capacity: '电池容量',
          battery_voltage: '电池电压',
          battery_current: '电池电流',
          battery_power: '电池功率',
          battery_soc: '电池SOC',
          battery_soh: '电池SOH',
          battery_day_charge: '电池当天充电量',
          battery_all_charge: '电池总充电量',
          battery_day_discharge: '电池当天放电量',
          battery_all_discharge: '电池总放电量',
          bms_title: 'BMS数据',
          bms_comm_status: 'BMS通讯状态',
          bms_software_version: 'BMS软件版本',
          bms_hardware_version: 'BMS硬件版本',
          bms_main_temperature: 'BMS主控温度',
          bms_voltage_charge_max: '最高充电电压',
          bms_voltage_discharge_min: '最低放电电压',
          bms_current_charge_max: '最大充电电流',
          bms_current_discharge_max: '最大放电电流',
          bms_voltage_monomer_max: '最高单体电压',
          bms_voltage_monomer_min: '最低单体电压',
          bms_temperature_monomer_max: '最高单体温度',
          bms_temperature_monomer_min: '最低单体温度',
          bms_voltage_monomer_max_id: '最高单体电压ID',
          bms_voltage_monomer_min_id: '最低单体电压ID',
          bms_temperature_monomer_max_id: '最高单体温度ID',
          bms_temperature_monomer_min_id: '最低单体温度ID',
          bms_charge_enable: '充电使能标志',
          bms_discharge_enable: '放电使能标志',
          bms_charge_forced: '强充标志',
          bms_status: '电池状态',
          bms_warn_code: 'BMS告警码',
          bms_fault_code: 'BMS故障码',
          bms_protect_code: 'BMS保护码',
          ev_title: 'EV数据',
          ev_v2gs_device: 'V2GS接入设备',
          ev_v2gs_fault: 'V2GS故障码',
          ev_connection_status: 'EV连接状态',
          ev_all_electricity: 'EV总电量',
          ev_voltage_max: 'EV最高电压',
          ev_current_max: 'EV最大电流',
          ev_full_soc: 'EV满充SOC',
          ev_demand_voltage: 'EV需求电压',
          ev_demand_current: 'EV需求电流',
          temperature_title: '温度',
          temperature_environment: '环境温度',
          temperature_radiator: '散热器温度',
          temperature_inv_r: 'INV模块R温度',
          temperature_inv_s: 'INV模块S温度',
          temperature_inv_t: 'INV模块T温度',
          other_title: '其他',
          other_real_time: '逆变器实时时间',
          other_485_agreement: '485协议',
          other_485_addr: '485地址设置',
          other_485_baud: '485波特率设置',
          other_485_2_addr: '485_2地址设置',
          other_485_2_baud: '485_2波特率设置',
          export_a: '逆变器',
          chart: {
            name: '逆变器统计图'
          }
        },
        inteless: {
          profile_title: '基本信息',
          profile_sn: '序列号',
          profile_power: '额定功率',
          profile_type: '设备类型',
          profile_status: '运行状态',
          profile_model: '型号',
          profile_sw_ver: '软件版本',
          profile_gateway: '采集器',
          profile_plant: '电站',
          profile_installer: '安装商',
          output_title: '输出信息',
          output_serial: '序列号',
          output_power: '额定输出功率',
          output_voltage: '机型PV额定电压',
          output_current: '机型PV额定充电电流',
          output_time: '逆变器时间',
          output_software_version1: '软件版本1',
          output_software_version2: '软件版本2',
          output_hardware_version1: '硬件版本1',
          output_hardware_version2: '硬件版本2',
          output_bms_version1: 'BMS版本1',
          output_bms_version2: 'BMS版本2',
          output_radiator_temperature: 'PV散热器温度',
          output_heat_sink: '逆变散热器温度',
          output_transformer_temperature: '变压器温度',
          output_positive_busbar_voltage: '正母线电压',
          output_negative_busbar_voltage: '负母线电压',
          output_machine: '机器当前状态',
          output_l1_voltage: 'L1 电压',
          output_l1_current: 'L1 电流',
          output_l2_voltage: 'L2 电压',
          output_l2_current: 'L2 电流',
          output_external_temperature: '外部温度',
          output_minor_version: '小版本号',
          output_rs485_address: '485地址',
          output_total_voltage: '总母线电压',
          input_title: '输入信息',
          input_pv1_voltage: 'PV1输入电压',
          input_pv1_current: 'PV1输入电流',
          input_pv1_power: 'PV1充电功率',
          input_pv2_voltage: 'PV2输入电压',
          input_pv2_current: 'PV2输入电流',
          input_pv2_power: 'PV2充电功率',
          input_pv_current: 'PV充电电流',
          input_pv_cumulative: 'PV累计发电量',
          input_pv_power: 'PV总充电功率',
          battery_title: '电池信息',
          battery_voltage: '蓄电池电压',
          battery_current: '蓄电池电流',
          battery_power: '蓄电池充放电功率',
          battery_soc: '蓄电池电量SOC',
          battery_status: '电池充电状态',
          battery_type: '电池类型',
          battery_charging_same_day: '电池当天充电安时数',
          battery_discharge_same_day: '电池当天放电安时数',
          battery_charging_ampere_hours: '电池当天放电安时数',
          battery_discharge_ampere_hours: '电池累计放电安时数',
          battery_soh: 'SOH',
          battery_rated_capacity: '蓄电池额定容量',
          battery_remain_capacity: '蓄电池剩余容量',
          battery_cycles: '电池充放电循环次数',
          battery_bms_voltage: '电池BMS电压',
          battery_bms_current: '电池BMS电流',
          battery_bms_temp: '电池BMS温度',
          battery_bms_charge_voltage: '电池BMS充电限压',
          battery_bms_charge_current: '电池BMS充电限流',
          battery_bms_discharge_current: '电池BMS放电限流',
          battery_alarms1: '报警1',
          battery_alarms2: '报警2',
          battery_protection1: '保护1',
          battery_protection2: '保护2',
          battery_bms_protocol: 'BMS协议',
          battery_ch_total_rate: '电池累计充电量',
          battery_dis_total_rate: '电池累计放电量',
          grid_title: '电网信息',
          grid_l1_voltage: 'L1市电电压',
          grid_l1_current: 'L1市电电流',
          grid_l1_power: 'L1市电有功功率',
          grid_l2_voltage: 'L2市电电压',
          grid_l2_current: 'L2市电电流',
          grid_l2_power: 'L2市电有功功率',
          grid_frequency: '市电频率',
          grid_charging_hours: '市电当天充电安时数',
          grid_l1_tv_power: 'L1市电视在功率',
          grid_l2_tv_power: 'L2市电视在功率',
          grid_charging_current: '市电充电电流',
          grid_grid_same_day: '当天并网电量',
          grid_accumulated_capacity: '市电累计充电量',
          grid_electricity_purchased: '当天购电量',
          grid_accumulated_purchased: '累计购电量',
          grid_accumulated_grid: '累计并网电量',
          grid_charging_power: '市电充电功率',
          grid_a_power_push: 'A相CT功率',
          grid_b_power_push: 'B相CT功率',
          grid_total_power: '电网总功率',
          load_title: '负载信息',
          load_l1_voltage: 'L1负载电压',
          load_l1_current: 'L1负载电流',
          load_l1_power: 'L1负载有功功率',
          load_l2_voltage: 'L2负载电压',
          load_l2_current: 'L2负载电流',
          load_l2_power: 'L2负载有功功率',
          load_l1_rate: 'L1负载率',
          load_l2_rate: 'L2负载率',
          load_l1_apparent_power: 'L1负载视在功率',
          load_l2_apparent_power: 'L2负载视在功率',
          load_frequency: '输出频率',
          load_electricity_consumption: '负载当天用电量',
          load_accumulated_power: '负载累计用电量',
          load_total_power: '负载总有功功率',
          load_total_apparent: '负载总视在功率'
        },
        sosen: {
          profile_title: '基本信息',
          profile_sn: '序列号',
          profile_power: '额定功率',
          profile_type: '设备类型',
          profile_status: '运行状态',
          profile_model: '型号',
          profile_sw_ver: '软件版本',
          profile_gateway: '采集器',
          profile_plant: '电站',
          profile_installer: '安装商',
          output_title: '输出信息',
          output_system_state: '系统运行状态',
          output_system_state_list: {
            'none': '',
            '0': '待机',
            '1': '充电',
            '2': '放电',
            '3': '故障',
            '4': '升级状态',
            '5': '不可用',
            '6': '锁定'
          },
          output_inv_state: 'INV运行状态',
          output_inv_state_list: {
            'none': '',
            '0': '关机',
            '1': '并网待机',
            '2': '离网待机',
            '3': '并网运行',
            '4': '离网运行',
            '5': '故障',
            '6': '旁路运行'
          },
          output_inv_volt_l1: 'L1逆变电压',
          output_inv_curr_l1: 'L1逆变电流',
          output_inv_p_l1: 'L1有功功率',
          output_inv_volt_l2: 'L2逆变电压',
          output_inv_curr_l2: 'L2逆变电流',
          output_inv_p_l2: 'L2有功功率',
          output_inv_freq: '逆变频率',
          output_operation_time: '逆变器运行时长',
          input_title: '输入信息',
          input_pv1_volt: 'PV1电压',
          input_pv1_curr: 'PV1电流',
          input_pv1_power: 'PV1功率',
          input_pv2_volt: 'PV2电压',
          input_pv2_curr: 'PV2电流',
          input_pv2_power: 'PV2功率',
          input_pv3_volt: 'PV3电压',
          input_pv3_curr: 'PV3电流',
          input_pv3_power: 'PV3功率',
          input_pv_power: 'PV总功率',
          input_pv_today: 'PV日电量',
          input_pv_total: 'PV总电量',
          battery_title: '电池信息',
          battery_bms_state: '电池状态',
          battery_bms_state_list: {
            '0': '空闲',
            '1': '充电',
            '2': '放电',
            '3': '禁止充电',
            '4': '禁止放电',
            '5': '禁止充放'
          },
          battery_bms_volt: '电池电压',
          battery_bms_curr: '电池电流',
          battery_bat_power: '电池功率',
          battery_soc: 'SOC',
          battery_soh: 'SOH',
          battery_bat_temp: '电池温度',
          battery_ch_max_volt: '充电截止电压',
          battery_disch_min_volt: '放电截止电压',
          battery_ch_max_curr: '最大充电电流',
          battery_disch_max_curr: '最大放电电流',
          grid_title: '电网信息',
          grid_freq: '电网频率',
          grid_volt_l1: 'L1电网电压',
          grid_curr_l1: 'L1电网电流',
          grid_p_l1: 'L1电网有功功率',
          grid_volt_l2: 'L2电网电压',
          grid_curr_l2: 'L2电网电流',
          grid_p_l2: 'L2电网有功功率',
          grid_import_today: '用电日电量',
          grid_import_total: '用电总电量',
          grid_export_today: '并网日电量',
          grid_export_total: '并网总电量',
          load_title: '负载信息',
          load_freq: '负载频率',
          load_volt_l1: 'L1负载电压',
          load_curr_l1: 'L1负载电流',
          load_p_l1: 'L1有功功率',
          load_volt_l2: 'L2负载电压',
          load_curr_l2: 'L2负载电流',
          load_p_l2: 'L2有功功率',
          load_e_today: '负载日电量',
          load_e_total: '负载总电量',
          load_p_total: '普通负载总有功'
        }
      },
      switchbox: {
        count_day_generation: '当日发电',
        count_day_use: '当日用电',
        count_day_buy: '当日买电',
        count_day_sale: '当日卖电',
        switchbox_status_text: '智能配电箱状态',
        switchbox_status: {
          'none': '',
          '0': '离线',
          '1': '在线',
          '2': '告警',
          '3': '待上线',
          '4': '故障'
        },
        network_status_text: '电网状态',
        network_status: {
          'none': '',
          '0': '离线',
          '1': '在线'
        },
        update_time: '更新时间',
        detail: {
          export_a: '智能配电箱',
          chart: {
            name: '智能配电箱统计图'
          },
          version_title: '版本信息',
          version_version: '版本号',
          version_sn: '设备序列号',
          version_factory: '生产厂家',
          version_hardware_version: '硬件版本号',
          version_firmware_version: '固件版本号',
          version_model: '设备型号',
          version_version_update_time: '版本更新时间'
        }
      },
      v2g: {
        count_day_generation: '当日发电',
        count_day_use: '当日用电',
        count_day_buy: '当日买电',
        count_day_sale: '当日卖电',
        count_grt_day: '当日充电量',
        count_grt_month: '当月充电量',
        count_grt_year: '当年充电量',
        count_grt_total: '总充电量',
        status: '当前状态',
        statusValue: {
          '1': '立即充电',
          '2': '立即放电',
          '3': '预约充电',
          '4': '预约放电',
          '5': '电网调度充电',
          '6': '电网调度放电',
          '7': '电费预约充电',
          '8': '电费预约放电'
        },
        soc: '当前SOC',
        power: '当前功率',
        workStatus: '工作状态',
        workStatusValue: {
          '0': '空闲未插枪',
          '1': '空闲已插枪',
          '2': '空闲故障',
          '3': '充电等待',
          '4': '充电中',
          '5': '充电暂停',
          '6': '充电结束',
          '7': '充电发生故障'
        },
        expChargeTime: '预约时间',
        expPower: '当前充电功率',
        ap: 'A相',
        bp: 'B相',
        cp: 'C相',
        apVoltage: 'A相电压',
        apCurrent: 'A相电流',
        apPower: 'A相功率',
        bpVoltage: 'B相电压',
        bpCurrent: 'B相电流',
        bpPower: 'B相功率',
        cpVoltage: 'C相电压',
        cpCurrent: 'C相电流',
        cpPower: 'C相功率',
        detail: {
          export_a: '充放电桩',
          chart: {
            name: '充放电桩统计图'
          },
          version_title: '版本信息',
          version_software_version: '软件版本号',
          version_protocol_version: '协议版本号',
          version_sn: '设备序列号',
          version_model: '设备型号',
          version_hardware_version: '硬件版本号',
          version_version_update_time: '版本更新时间',
          charge_title: '立即充电信息',
          charge_power: '限制功率',
          charge_soc: '限制SOC',
          charge_feedNetwork: '馈网',
          discharge_title: '立即放电信息',
          discharge_power: '限制功率',
          discharge_soc: '限制SOC',
          discharge_feedNetwork: '馈网',
          make_charge_title: '预约充电信息',
          make_charge_power: '限制功率',
          make_charge_soc: '限制SOC',
          make_charge_feedNetwork: '馈网',
          make_discharge_title: '预约放电信息',
          make_discharge_time_title: '预约充放电时间',
          make_discharge_power: '限制功率',
          make_discharge_soc: '限制SOC',
          make_discharge_feedNetwork: '馈网',
          dispatch_title: '电网调度信息',
          dispatch_time: '调度时间',
          dispatch_feedNetwork: '馈网',
          optimize_title: '电费优化信息',
          optimize_power: '限制功率',
          optimize_soc: '限制SOC',
          optimize_feedNetwork: '馈网',
          off_title: '离网配置信息',
          off_soc: '限制SOC',
          off_discharge: '立即放电',
          device_title: '设备信息',
          device_current: '单次充电量',
          device_quantity: '正向总有功电量',
          device_cp: '当前CP状态',
          device_equipment: '充电桩编号',
          device_version: '版本号',
          device_server: '服务器链接',
          device_currCpStatusValue: {
            '0': 'CP12 未连接',
            '1': 'CP12 PWM',
            '2': 'CP9 已连接',
            '3': 'CP9 PWM',
            '4': 'CP6 充电',
            '5': 'CP6 PWM',
            '6': '错误'
          },
          feedNetwork: {
            '0': '馈网',
            '1': '不馈网'
          },
          offlineDisNow: {
            '0': '不放电',
            '1': '放电'
          }
        }
      },
      charge: {
        detail: {
          chart: {
            name: '充电桩统计图'
          }
        }
      },
      collector: {
        preview_sn: '序列号',
        preview_key: '注册码',
        preview_plant: '电站',
        preview_customer: '客户',
        preview_owner: '拥有者',
        preview_mcu_ver: '主处理器',
        preview_hw_ver: '硬件版本',
        preview_model: '型号',
        preview_ssid: '路由器SSID',
        preview_router_address: '路由器MAC地址',
        preview_wifi_address: 'Wi-Fi MAC地址',
        preview_ble_address: '蓝牙MAC地址'
      },
      made: {
        title: '参数设置'
      },
      madeAll: {
        title: '参数批量设置'
      }
    },
    manage: {
      entered: '已入电站',
      notEntered: '未入电站',
      notonline: '未配网',
      online: '已配网',
      statistics: '设备统计',
      template: '导入模板下载',
      table: {
        serial: '产品序列号',
        deviceType: '设备类型',
        deviceType_placeholder: '请选择设备类型',
        owner:'业主',
        installer: '安装商',
        installer_placeholder: '请输入安装商',
        dealer: '经销商',
        dealer_placeholder: '请输入经销商',
        country: '国家',
        country_placeholder: '请选择国家',
        installTime: '安装时间',
        installTime_range: '至',
        installTime_start: '开始时间',
        installTime_end: '结束时间',
        import: '导入',
        createTime: '导入时间',
        firstOnTime: '首次在线时间',
        onOffTime: '离线时间',
        importTime: '导入时间',
        importTime_range: '至',
        importTime_start: '开始时间',
        importTime_end: '结束时间',
        deliveryTime: '发货时间',
        dataSourceType: '数据来源'
      },
      installer: {
        title: '批量设置安装商',
        installer_placeholder: '查询安装商',
        installer_select_empty: '请选择安装商'
      }
    },
    made: {
      save: '设置',
      reset: '重置',
      input: '请输入',
      select: '请选择',
      pitch: '节',
      num: '个',
      min: '分',
      dialog_title: '设置确认',
      id: 'ID',
      sn: 'SN',
      empty: '没有可设置的内容',
      import: '导入配置',
      battery: {
        title: '电池设置',
        control: '控制',
        control_volume: '系统剩余容量',
        control_relay: '继电器{data}强控',
        control_restore: '出厂还原',
        control_erase: '擦除历史',
        control_default: '默认配置',
        control_reset: '复位',
        bms_reset: 'BMS重置',
        system: '系统',
        system_address: '地址编号',
        system_bmu: 'BMU个数',
        system_slave_battery: '从机电池数',
        system_slave_warm: '从机温感数',
        system_nominal_volume: '系统标称容量',
        system_all_volume: '系统总容量',
        system_slave_data_cycle: '请求从机数据周期',
        system_slave_response_timeout: '从机响应超时时间',
        system_battery_rated_voltage: '电池额定总压',
        system_data_storage_cycle: '数据存储周期',
        system_can_baud: 'CAN波特率',
        system_485_1_baud: '485_1波特率',
        system_485_2_baud: '485_2波特率',
        system_485_1_check: '485_1校验位',
        system_485_2_check: '485_2校验位',
        system_485_address: '485地址',
        system_sensor_type_includes: '电流传感器类型包含分流器的25mV75mV',
        system_current_sensor_range: '电流传感器量程',
        system_zero_filtering_range: '电流传感器零点滤波范围',
        system_reverse_connection_sensor: '电流传感器反接',
        system_type: '电池类型',
        system_power_diagnosis_low: '上电自诊断类型低位',
        system_power_diagnosis_high: '上电自诊断类型高位',
        system_fan_on_temperature: '风扇开启温度',
        system_fan_off_temperature: '风扇关闭温度',
        system_heating_on_temperature: '加热开启温度',
        system_heating_off_temperature: '加热关闭温度',
        system_heating_off: '加热关闭SOC',
        system_heating_temperature_protection: '加热温度保护',
        system_heating_temperature_release: '加热温度释放',
        system_heating_temperature_sensing: '加热温感数',
        system_insulation_testing_cycle: '绝缘检测周期',
        system_insulation_collection_enable: '绝缘采集使能',
        system_insulation_collection_delay: '绝缘采集延时',
        system_balanced_opening_voltage: '均衡开启电压',
        system_balanced_opening_mode: '均衡开启模式',
        system_balanced_opening_difference: '均衡开启压差',
        system_balanced_closing_difference: '均衡关闭压差',
        system_env_temperature_sensing: '环境温感{data}使能',
        system_sleep_time: '休眠时间',
        system_agreement: '协议',
        system_parallel: '并机系统',
        system_parallel_current: '并机系统电流比例',
        system_balanced_opening_sensing: '均衡开启使能',
        charge_discharge: '充放电参数',
        charge_discharge_rated_charging_current: '额定充电电流',
        charge_discharge_rated_discharge_current: '额定放电电流',
        charge_discharge_charging_cutoff_voltage: '充电截止电压',
        charge_discharge_first_alarm_coefficient: '一级报警降流系数',
        charge_discharge_second_alarm_coefficient: '二级报警降流系数',
        charge_discharge_first_down_voltage: '充电一档降流电压点',
        charge_discharge_second_down_voltage: '充电二档降流电压点',
        charge_discharge_first_gear_coefficient: '充电一档降流系数',
        charge_discharge_second_gear_coefficient: '充电二档降流系数',
        charge_discharge_recovery_release_value: '充电恢复SOC高释放值',
        charge_discharge_recovery_voltage_release: '充电恢复电压释放值',
        charge_discharge_discharge_recovery_low: '放电恢复soc低释放值',
        charge_discharge_discharge_recovery_release: '放电恢复电压低释放值',
        charge_discharge_full_charge_voltage: '满充校准电压',
        charge_discharge_vacuum_calibration_voltage: '放空校准电压',
        charge_discharge_strong_charge_enable: '强冲使能',
        charge_discharge_full_charge_enable: '强制满充使能',
        charge_discharge_strong_charge_on: '强冲开启SOC',
        charge_discharge_Strong_charge_off: '强冲关闭SOC',
        charge_discharge_full_charge_days: '满充开启天数',
        charge_discharge_high_limit_voltage: '总压高限流电压',
        charge_discharge_high_limit_ratio: '总压高限流比例',
        charge_discharge_low_limit_voltage: '总压低限流电压',
        charge_discharge_low_limit_ratio: '总压低限流比例',
        charge_discharge_strong_charge_timeout_alarm: '强充超时报警',
        charge_discharge_floating_limiting_voltage: '浮充限流电压',
        charge_discharge_floating_limiting_current: '浮充限流电流',
        charge_discharge_floating_limiting_timeout: '浮充超时时间',
        charge_discharge_charging_request_start_time_1: '充电请求开始时区1',
        charge_discharge_charging_request_end_time_1: '充电请求结束时区1',
        charge_dischargee_charging_request_start_time_2: '充电请求开始时区2',
        charge_discharge_charging_request_end_time_2: '充电请求结束时区2',
        charge_discharge_charging_request_start_time_3: '充电请求开始时区3',
        charge_discharge_charging_request_end_time_3: '充电请求结束时区3',
        charge_discharge_heating_start_time_1: '加热开启时区1',
        charge_discharge_heating_end_time_1: '加热结束时区1',
        charge_discharge_request_duration: '充电请求持续时间',
        charge_discharge_request_interval: '充电请求间隔',
        high_voltage: '高压上电',
        high_voltage_relay_type: '继电器{data}类型配置',
        high_voltage_di_type: 'DI{data}类型',
        high_voltage_charge_voltage_ratio: '预充电压比例',
        high_voltage_voltage_power_delay: '高压上电延迟',
        high_voltage_charge_completion_timeout: '预充完成超时时间',
        high_voltage_charge_closure_time: '预充闭合最长时间',
        high_voltage_charge_times: '预充次数',
        high_voltage_voltage_delay: '高压下电延时',
        high_voltage_open_circuit_detection: '支持开路检测',
        high_voltage_support_adhesion_detection: '支持粘连检测',
        high_voltage_support_pre_charging: '支持预充',
        high_voltage_copy_check_voltage_rate: '粘连检测电压比例',
        soc: 'SOC',
        soc_capacity_decay_cycles: '70%容量衰减循环次数',
        soc_capacity_decay_low: '70%容量衰减累计容量低位',
        soc_capacity_decay_high: '70%容量衰减累计容量高位',
        soc_correction_rate_change: 'SOC校正变化率',
        soc_calibration_interval_time: 'Ocv校正间隔时间',
        soc_correction_settling_time: 'Ocv校正静置时间',
        soc_correction_step_size: 'Ocv校正步长',
        soc_correction_cutoff_current: 'Ocv校正截止电流',
        soc_virtual_low_holding: 'Soc虚低保持值',
        soc_virtual_low_voltage: 'Soc虚低电压值',
        soc_battery_capacity_ratio_1: '10摄氏度电池可用容量比',
        soc_battery_capacity_ratio_2: '0摄氏度电池可用容量比',
        soc_battery_capacity_ratio_3: '负10摄氏度电池可用容量比',
        soc_battery_capacity_ratio_4: '负20摄氏度电池可用容量比',
        charge: '充电故障',
        charge_high_charging_pressure_1: '充电总压高一级报警',
        charge_high_charging_pressure_2: '充电总压高二级报警',
        charge_high_charging_pressure_3: '充电总压高三级报警',
        charge_charging_unit_1: '充电单体高一级报警',
        charge_charging_unit_2: '充电单体高二级报警',
        charge_charging_unit_3: '充电单体高三级报警',
        charge_charging_pressure_difference_1: '充电压差一级报警',
        charge_charging_pressure_difference_2: '充电压差二级报警',
        charge_charging_pressure_difference_3: '充电压差三级报警',
        charge_charging_high_temperature_1: '充电高温一级报警',
        charge_charging_high_temperature_2: '充电高温二级报警',
        charge_charging_high_temperature_3: '充电高温三级报警',
        charge_charging_temperature_difference_1: '充电温差一级报警',
        charge_charging_temperature_difference_2: '充电温差二级报警',
        charge_charging_temperature_difference_3: '充电温差三级报警',
        charge_low_temperature_charging_1: '充电低温一级报警',
        charge_low_temperature_charging_2: '充电低温二级报警',
        charge_low_temperature_charging_3: '充电低温三级报警',
        charge_charging_overcurrent_1: '充电过流一级报警',
        charge_charging_overcurrent_2: '充电过流二级报警',
        charge_charging_overcurrent_3: '充电过流三级报警',
        discharge: '放电故障',
        discharge_low_discharge_pressure_1: '放电总压低一级报警',
        discharge_low_discharge_pressure_2: '放电总压低二级报警',
        discharge_low_discharge_pressure_3: '放电总压低三级报警',
        discharge_low_discharge_monomer_1: '放电单体低一级报警',
        discharge_low_discharge_monomer_2: '放电单体低二级报警',
        discharge_low_discharge_monomer_3: '放电单体低三级报警',
        discharge_discharge_voltage_difference_1: '放电压差一级报警',
        discharge_discharge_voltage_difference_2: '放电压差二级报警',
        discharge_discharge_voltage_difference_3: '放电压差三级报警',
        discharge_high_discharge_temperature_1: '放电高温一级报警',
        discharge_high_discharge_temperature_2: '放电高温二级报警',
        discharge_high_discharge_temperature_3: '放电高温三级报警',
        discharge_discharge_temperature_difference_1: '放电温差一级报警',
        discharge_discharge_temperature_difference_2: '放电温差二级报警',
        discharge_discharge_temperature_difference_3: '放电温差三级报警',
        discharge_low_discharge_temperature_1: '放电低温一级报警',
        discharge_low_discharge_temperature_2: '放电低温二级报警',
        discharge_low_discharge_temperature_3: '放电低温三级报警',
        discharge_discharge_overcurrent_1: '放电过流一级报警',
        discharge_discharge_overcurrent_2: '放电过流二级报警',
        discharge_discharge_overcurrent_3: '放电过流三级报警',
        relay: '继电器',
        relay_high_temperature_1: '继电器高温一级报警',
        relay_high_temperature_2: '继电器高温二级报警',
        relay_high_temperature_3: '继电器高温三级报警',
        relay_low_temperature_1: '继电器低温一级报警',
        relay_low_temperature_2: '继电器低温二级报警',
        relay_low_temperature_3: '继电器低温三级报警',
        common: '通用故障',
        common_low_soc_1: 'SOC低一级报警',
        common_low_soc_2: 'SOC低二级报警',
        common_low_soc_3: 'SOC低三级报警',
        common_insulation_leakage_1: '绝缘漏电一级报警',
        common_insulation_leakage_2: '绝缘漏电二级报警',
        common_insulation_leakage_3: '绝缘漏电三级报警',
        common_temperature_rise_alarm_1: '温升报警一级报警',
        common_temperature_rise_alarm_2: '温升报警二级报警',
        common_temperature_rise_alarm_3: '温升报警三级报警',
        common_high_temperature_env_1: '环境高温一级报警',
        common_high_temperature_env_2: '环境高温二级报警',
        common_high_temperature_env_3: '环境高温三级报警',
        common_low_temperature_env_1: '环境低温一级报警',
        common_low_temperature_env_2: '环境低温二级报警',
        common_low_temperature_env_3: '环境低温三级报警',
        common_circulation_1: '环流一级报警',
        common_circulation_2: '环流二级报警',
        common_circulation_3: '环流三级报警',
        common_abnormal_voltage_cable_1: '电压排线检测异常一级报警',
        common_abnormal_voltage_cable_2: '电压排线检测异常二级报警',
        common_abnormal_voltage_cable_3: '电压排线检测异常三级报警',
        common_temperature_detection_abnormality_1: '温度检测排线异常一级报警',
        common_temperature_detection_abnormality_2: '温度检测排线异常二级报警',
        common_temperature_detection_abnormality_3: '温度检测排线异常三级报警',
        table_name: '名称',
        table_threshold: '阈值',
        table_release_threshold: '释放阈值',
        table_delayed: '延时',
        table_release_delayed: '释放延时',
        table_handle: '处理',
        high_voltage_open_circuit_delay: '开路检测延时',
        high_voltage_support_adhesion_delay: '粘连检测延时',
        soc_high_auxiliary_check_point: 'SOC容量高辅助校准点',
        soc_low_auxiliary_check_point: 'SOC容量低辅助校准点',
        high_current_socHigh_auxiliary_check_voltage: '电流大档SOC容量高辅助校准电压值',
        middle_current_socHigh_auxiliary_check_voltage: '电流中档SOC容量高辅助校准电压值',
        low_current_soc_high_auxiliary_check_voltage: '电流小档SOC容量高辅助校准电压值',
        high_current_soc_low_auxiliary_check_voltage: '电流大档SOC容量低辅助校准电压值',
        middle_current_soc_low_auxiliary_check_voltage: '电流中档SOC容量低辅助校准电压值',
        low_current_soc_low_auxiliary_check_voltage: '电流小档SOC容量低辅助校准电压值',
        soc_high_auxiliary_check_voltage_high_current: 'SOC容量高辅助校准电流大档值',
        soc_high_auxiliary_check_voltage_middle_current: 'SOC容量高辅助校准电流中档值',
        soc_high_auxiliary_check_voltage_low_current: 'SOC容量高辅助校准电流小档值',
        soc_low_auxiliary_check_voltage_high_current: 'SOC容量低辅助校准电流大档值',
        soc_low_auxiliary_check_voltage_middle_current: 'SOC容量低辅助校准电流中档值',
        soc_low_auxiliary_check_voltage_low_current: 'SOC容量低辅助校准电流小档值',
        soc_low_auxiliary_check_voltage_keep_time: 'Soc容量低辅助校准电压保持时间',
        soc_total_charging: '累计充电容量',
        soc_total_discharge: '累计放电容量',
        soc_total_charge_discharge_cycles: '充放电循环次数'
      },
      inverter: {
        megmeet: {
          title: '逆变器设置',
          systemSettings: '系统设置',
          systemControl: '系统控制',
          systemParams: '系统安规参数',
          backwash: '防逆流设置',
          energy: '能量管理设置',
          time: '时间段{data}模式设置',
          systemSettings_real_time: '逆变器实时时间',
          systemSettings_model: '逆变器机型',
          systemSettings_code: '逆变器编码',
          systemSettings_device_model: '逆变器设备型号',
          systemSettings_manufacturer: '逆变器厂商',
          systemSettings_battery_manufacturer: '电池厂商',
          systemSettings_meter_manufacturer: '电表厂商',
          systemSettings_485_protocol: '485协议',
          systemSettings_485_address: '485地址',
          systemSettings_485_baud: '485波特率',
          systemSettings_485_2_address: '485_2地址',
          systemSettings_485_2_baud: '485_2波特率',
          systemControl_shutdown: '远程关机',
          systemControl_clearing_power: '清除发电量',
          systemControl_clearing_fault: '清除故障记录',
          systemControl_factory_settings: '恢复出厂设置',
          systemParams_rule: '法规',
          systemParams_undervoltage_value_1: '电网欠压一级保护值',
          systemParams_undervoltage_value_2: '电网欠压二级保护值',
          systemParams_undervoltage_value_3: '电网欠压三级保护值',
          systemParams_overvoltage_value_1: '电网过压一级保护值',
          systemParams_overvoltage_value_2: '电网过压二级保护值',
          systemParams_undervoltage_time_1: '电网欠压一级保护时间',
          systemParams_undervoltage_time_2: '电网欠压二级保护时间',
          systemParams_undervoltage_time_3: '电网欠压三级保护时间',
          systemParams_overvoltage_time_1: '电网过压一级保护时间',
          systemParams_overvoltage_time_2: '电网过压二级保护时间',
          systemParams_undervoltage_differ_value: '电网欠压保护回差值',
          systemParams_overvoltage_differ_value: '电网过压保护回差值',
          systemParams_underfrequent_value_1: '电网欠频一级保护值',
          systemParams_underfrequent_value_2: '电网欠频二级保护值',
          systemParams_overfrequent_value_1: '电网过频一级保护值',
          systemParams_overfrequent_value_2: '电网过频二级保护值',
          systemParams_underfrequent_time_1: '电网欠频一级保护时间',
          systemParams_underfrequent_time_2: '电网欠频二级保护时间',
          systemParams_overfrequent_time_1: '电网过频一级保护时间',
          systemParams_overfrequent_time_2: '电网过频二级保护时间',
          systemParams_underfrequent_differ_value: '电网欠频保护回差值',
          systemParams_overfrequent_differ_value: '电网过频保护回差值',
          backwash_reflux_function: '防逆流功能',
          backwash_reflux_power: '防逆流功率',
          energy_mode: '能量管理模式',
          energy_charging_power: '充电功率百分比',
          energy_discharge_power: '放电功率百分比',
          energy_stop_soc: '充电停止SOC',
          energy_deep_dod: '电池放电深度DOD',
          time_header_name: '名称',
          time_header_mode: '模式',
          time_header_startTime: '开始时间',
          time_header_endTime: '结束时间',
          time_header_charge_mode: '充放电模式',
          time_header_charge_power: '充放电功率百分比(%)',
          time_header_charge_soc: '充放电停止SOC(%)'
        },
        luxpowertek: {
          title: '逆变器设置',
          generalSettings: '通用设置',
          generalSettings_time: '时间',
          systemSettings_model_addr: 'MODBUS地址',
          systemSettings_pv_input_mode: 'PV接线方式',
          systemSettings_neutral_detect_enable: '零地检测使能',
          systemSettings_star_pv_volt: 'Start PV Volt',
          systemSettings_model: 'Model',
          systemSettings_measurement: '检测方式',
          systemSettings_meter_type: '电表类型',
          systemSettings_ct_sample_ratio: 'CT采样比',
          systemSettings_ct_direction_reversed: '反转CT方向',
          systemSettings_ct_power_offset: 'CT功率补偿',
          systemSettings_battery_type: '电池类型',
          systemSettings_lead_acid_capacity: '铅酸电池类型',
          systemSettings_ead_acid_battery_setting: '铅酸电池设置',
          systemSettings_absorb_voltage: '均充电压',
          systemSettings_float_voltage: '浮充电压',
          systemSettings_on_grid_discharge_derate_vbatt: '铅酸电池欠压降载点',
          systemSettings_lithium_brand: '锂电池品牌',
          systemSettings_reuse_of_pv_ct: 'PV CT 复用',
          systemSettings_ios_enable: 'ISO使能',
          systemSettings_firmware_version: '版本号',
          systemSettings_lcd_version: 'LCD固件版本',
          systemSettings_lcd_password: 'LCD密码',
          applicationSettings: '应用设置',
          applicationSettings_eps_voltage_set: '离网输出电压设置',
          applicationSettings_pv_grid_off: 'PV离网',
          applicationSettings_power_backup: '离网模式使能',
          applicationSettings_seamless_eps_switching: '离网模式无缝切换使能',
          applicationSettings_grid_sell_back: '并网',
          applicationSettings_grid_sell_back_power: '并网功率',
          applicationSettings_fast_zero_export: '快速防逆流',
          applicationSettings_go_to_off_grid: '进入离网运行',
          applicationSettings_pv_arc: 'PV侧电弧检测',
          applicationSettings_pv_arc_fault_clear: '电弧检测告警清除',
          applicationSettings_grid_loss_warning_clear: '无市电输入',
          applicationSettings_rsd: 'RSD',
          applicationSettings_normal_standby: '开机/待机',
          applicationSettings_restart_inverter: '重启逆变器',
          applicationSettings_micro_grid: '微网使能',
          applicationSettings_max_ac_input_power: '电网最大输入功率',
          applicationSettings_system_charge_soc_limit: '系统充电SOC限值',
          applicationSettings_system_charge_volt_limit: '系统充电电压限值',
          applicationSettings_Parallel_system: '并机系统',
          applicationSettings_set_system_type: '系统类型',
          applicationSettings_share_battery: '共享电池模式',
          applicationSettings_set_composed_phase: '设置组网相位',
          gridSettings: '并网设置',
          gridSettings_grid_regulation: '并网法规',
          gridSettings_grid_frequency: '电网频率',
          gridSettings_grid_type: '电网类型',
          gridSettings_connection: '并网',
          gridSettings_connect_time: '并网等待时间',
          gridSettings_reconnect_time: '重新并网等待时间',
          gridSettings_grid_volt_connect_low: '并网市电电压下限',
          gridSettings_grid_volt_connect_high: '并网市电电压上限',
          gridSettings_grid_freq_connect_low: '并网市电频率下限',
          gridSettings_grid_freq_connect_high: '并网市电频率上限',
          gridSettings_power_command: '功率控制',
          gridSettings_active_power_percent: '有功百分比设定值',
          gridSettings_ovf_load_derate_enable: '过频降载使能',
          gridSettings_reactive_power_type: '无功输出模式',
          gridSettings_drms_enable: 'DRMS使能',
          gridSettings_pf_cmd: 'PF设定值',
          gridSettings_reactive_power_percent: '无功百分比设定值',
          gridSettings_grid_protection: '市电充电',
          gridSettings_grid_volt_limit1_low: '电网电压1级欠压保护点',
          gridSettings_grid_volt_limit2_low: '电网电压2级欠压保护点',
          gridSettings_grid_volt_limit3_low: '电网电压3级欠压保护点',
          gridSettings_grid_volt_limit1_high: '电网电压1级过压保护点',
          gridSettings_grid_volt_limit2_high: '电网电压2级过压保护点',
          gridSettings_grid_volt_limit3_high: '电网电压3级过压保护点',
          gridSettings_grid_freq_limit1_low: '电网频率1级欠频保护点',
          gridSettings_grid_freq_limit2_low: '电网频率2级欠频保护点',
          gridSettings_grid_freq_limit3_low: '电网频率3级欠频保护点',
          gridSettings_grid_freq_limit1_high: '电网频率1级过频保护点',
          gridSettings_grid_freq_limit2_high: '电网频率2级过频保护点',
          gridSettings_grid_freq_limit3_high: '电网频率3级过频保护点',
          gridSettings_grid_volt_mov_avg_high: '电网电压滑动平均过压保护点',
          gridSettings_power_soft_start_slope: '加载速率',
          gridSettings_grid_soft_start: 'Grid Soft Start',
          chargeSettings: '充电设置',
          chargeSettings_batt_charge_control: 'Batt Charge Control',
          chargeSettings_charge_current_limit: '充电电流限制(Adc)',
          chargeSettings_charge_last: '最后充电',
          chargeSettings_ac_charge: '交流充电',
          chargeSettings_ac_charge_enable: 'AC充电使能',
          chargeSettings_ac_charge_based_on: 'AC充电控制依据',
          chargeSettings_ac_charge_power: 'AC充电功率',
          chargeSettings_start_ac_charge_soc: 'AC充电启动SOC',
          chargeSettings_start_ac_charge_volt: 'AC充电启动电压',
          chargeSettings_stop_ac_charge_soc: 'AC充电截止SOC',
          chargeSettings_stop_ac_charge_volt: 'AC充电截止电压',
          chargeSettings_ac_charge_start_time_1: 'AC充电起始时间1',
          chargeSettings_ac_charge_start_time_2: 'AC充电起始时间2',
          chargeSettings_ac_charge_start_time_3: 'AC充电起始时间3',
          chargeSettings_ac_charge_end_time_1: 'AC充电结束时间1',
          chargeSettings_ac_charge_end_time_2: 'AC充电结束时间2',
          chargeSettings_ac_charge_end_time_3: 'AC充电结束时间3',
          chargeSettings_charge_first_title: '充电优先级',
          chargeSettings_charge_first: 'PV充电优先',
          chargeSettings_charge_first_power: '充电优先功率',
          chargeSettings_Stop_charge_first_soc: '充电优先截止SOC',
          chargeSettings_Stop_charge_first_volt: '充电优先截止电压',
          chargeSettings_charge_first_start_time_1: '电池充电优先起始时间1',
          chargeSettings_charge_first_start_time_2: '电池充电优先起始时间2',
          chargeSettings_charge_first_start_time_3: '电池充电优先起始时间3',
          chargeSettings_charge_first_end_time_1: '电池充电优先结束时间1',
          chargeSettings_charge_first_end_time_2: '电池充电优先结束时间2',
          chargeSettings_charge_first_end_time_3: '电池充电优先结束时间3',
          generatorSettings: '发电机设置',
          generatorSettings_batt_charge_current_limit: '电池充电电流限制(Adc)',
          generatorSettings_gen_rated_power: '发电机额定功率',
          generatorSettings_charge_start_volt: '充电启动电压',
          generatorSettings_charge_start_soc: '充电启动SOC',
          generatorSettings_charge_end_volt: '充电截止电压',
          generatorSettings_charge_end_soc: '充电截止SOC',
          disChargeSettings: '放电设置',
          disChargeSettings_batt_discharge_control: '电池放电控制依据',
          disChargeSettings_discharge_current_limit: '放电电流限制(Adc)',
          disChargeSettings_start_discharge_p_import: '放电起始功率设置',
          disChargeSettings_on_grid_cut_off_soc: '并网放电截止SOC限值',
          disChargeSettings_off_grid_cut_off_soc: '离网放电截止SOC限值',
          disChargeSettings_on_grid_cut_off_volt: '并网截止电电压',
          disChargeSettings_off_grid_cut_off_volt: '离网截止电压',
          disChargeSettings_forced_discharge: '强制放电',
          disChargeSettings_forced_discharge_enable: '强制放电使能',
          disChargeSettings_forced_discharge_power: '强制放电功率',
          disChargeSettings_stop_discharge_soc: '强制放电SOC限值',
          disChargeSettings_stop_discharge_volt: '强制放电截止电压',
          disChargeSettings_pvsell_to_grid: 'PVSellToGrid(Comp. w/ NEM3.0)',
          disChargeSettings_forced_discharge_start_time_1: '强制放电起始时间1',
          disChargeSettings_forced_discharge_start_time_2: '强制放电起始时间2',
          disChargeSettings_forced_discharge_start_time_3: '强制放电起始时间3',
          disChargeSettings_forced_discharge_end_time_1: '强制放电结束时间1',
          disChargeSettings_forced_discharge_end_time_2: '强制放电结束时间2',
          disChargeSettings_forced_discharge_end_time_3: '强制放电结束时间3',
          disChargeSettings_peak_shaving: 'Peak Shaving',
          disChargeSettings_grid_peak_shaving: '电网Peak-Shaving',
          disChargeSettings_grid_peak_shaving_power_1: '电网Peak-Shaving功率1',
          disChargeSettings_grid_peak_shaving_power_2: '电网Peak-Shaving功率2',
          disChargeSettings_start_peak_shaving_volt_1: 'Peak-Shaving启动电压1',
          disChargeSettings_start_peak_shaving_soc_1: 'Peak-Shaving启动SOC1',
          disChargeSettings_start_peak_shaving_volt_2: 'Peak-Shaving启动电压2',
          disChargeSettings_start_peak_shaving_soc_2: 'Peak-Shaving启动SOC2',
          disChargeSettings_peak_shaving_start_time_1: 'Peak Shaving启动时间1',
          disChargeSettings_peak_shaving_start_time_2: 'Peak Shaving启动时间2',
          disChargeSettings_peak_shaving_end_time_1: 'Peak Shaving截止时间1',
          disChargeSettings_peak_shaving_end_time_2: 'Peak Shaving截止时间2',
          disChargeSettings_ac_couple_title: 'AC Couple',
          disChargeSettings_ac_couple: 'AC Couple',
          disChargeSettings_ac_couple_start_volt: 'AC Couple启动电压',
          disChargeSettings_ac_couple_start_soc: 'AC Couple启动SOC',
          disChargeSettings_ac_couple_end_volt: 'AC Couple截止电压',
          disChargeSettings_ac_couple_end_soc: 'AC Couple截止SOC',
          disChargeSettings_smart_load_title: 'Smart Load',
          disChargeSettings_smart_load: 'Smart Load',
          disChargeSettings_start_pv_power: '启动PV功率',
          disChargeSettings_grid_always_on: '并网时常开',
          disChargeSettings_smart_load_start_volt: 'Smart Load启动电压',
          disChargeSettings_smart_load_start_soc: 'Smart Load启动SOC',
          disChargeSettings_smart_load_end_volt: 'Smart Load截止电压',
          disChargeSettings_smart_load_end_soc: 'Smart Load截止SOC',
          resetSettings: '重置操作',
          resetSettings_all_to_default: '系统设置恢复默认值',
          collectorSettings: '采集器设置 - BA32001486 - Wi-Fi',
          collectorSettings_server_ip_and_port: 'Server IP and Port'
        },
        inteless: {
          title: '逆变器设置',
          basicSettings: '基础设置',
          basicSettings_alarm: '蜂鸣器报警',
          basicSettings_password_input: '密码输入',
          basicSettings_password_setting: '密码设置',
          basicSettings_model: '机型ID设置',
          modeSettings: '工作模式设置',
          modeSettings_grid_mode: '离并网工作模式',
          modeSettings_charging_enable: '市电充电使能',
          modeSettings_pv_energy_manage: '光伏能量管理设置',
          modeSettings_battery_energy_manage: '电池放电能量管理设置',
          modeSettings_wiring_type: 'AC端接线类型',
          modeSettings_output_voltage: '输出电压设置',
          modeSettings_timing_charging: '定时充电使能',
          modeSettings_timing_discharging: '定时放电使能',
          modeSettings_table_name: '名称',
          modeSettings_table_startTime: '开始时间',
          modeSettings_table_endTime: '结束时间',
          modeSettings_table_maxPower: '最大功率(W)',
          modeSettings_table_stopSoc: '停止SOC(%)',
          modeSettings_table_1: '削峰填谷定时充电时段1',
          modeSettings_table_2: '削峰填谷定时充电时段2',
          modeSettings_table_3: '削峰填谷定时充电时段3',
          modeSettings_table_4: '削峰填谷定时放电时段1',
          modeSettings_table_5: '削峰填谷定时放电时段2',
          modeSettings_table_6: '削峰填谷定时放电时段3',
          modeSettings_parallel_mode: '并机模式设置',
          batterySettings: '电池设置',
          batterySettings_type: '电池类型',
          batterySettings_bms_enable: 'BMS通信使能',
          batterySettings_bms_protocol: 'BMS通信协议选择',
          batterySettings_mode: '电池充电限流模式',
          batterySettings_max_charging_current: '最大充电电流',
          batterySettings_max_charging_voltage: '最大充电电压',
          batterySettings_stop_discharge_voltage: '过放电压',
          batterySettings_stop_dchg_delay_time: '截止放电延时时间',
          batterySettings_battery_under_volt_alarm: '电池欠压告警',
          batterySettings_eod_recovery_voltage: '截止放电恢复电压',
          batterySettings_batt_Recharging_voltage: '电池恢复充电电压',
          batterySettings_max_chg_curr_by_grid: '市电最大充电电流',
          batterySettings_battery_curr_stop_chg: '电池停止充电电流',
          batterySettings_batt_soc_low_alarm: '电池欠容告警容量',
          batterySettings_discharge_cutoff_soc: '放电截止SOC',
          batterySettings_bat_soc_stop_chg: '电池停止充电容量',
          batterySettings_mains_switching_voltage: '市电切换电压',
          batterySettings_switch_the_city_electric: '切换市电SOC容量点',
          batterySettings_max_batt_discharg_current: '电池最大放电电流',
          batterySettings_batt_temp_compen_enable: '电池温度补偿使能',
          parallelSettings: '并网设置',
          parallelSettings_grid_standard: '并网标准设置',
          parallelSettings_grid_frequency: '电网频率',
          parallelSettings_buy_power_max: '买电最大功率',
          parallelSettings_sell_power_max: '卖电最大功率(光伏+电池)',
          parallelSettings_ct_ratio: 'CT变比',
          parallelSettings_zero_export_power: '防逆流限功误差',
          parallelSettings_on_grid_reactive_power: '并网无功功率',
          parallelSettings_on_grid_pf: '并网功率因数',
          parallelSettings_enter_service_enable: '并网连接使能',
          parallelSettings_normal_connect_delay_time: '正常连接延时时间',
          parallelSettings_normal_connect_power_ramp_rate: '正常连接功率上升速率',
          parallelSettings_connect_voltage_low_point: '并网连接最低电压',
          parallelSettings_connect_voltage_high_point: '并网连接最高电压',
          parallelSettings_connect_frequency_low_point: '并网连接最低频率',
          parallelSettings_connect_frequency_high_point: '并网连接最高频率',
          parallelSettings_reconnect_delay_time: '重连并网延时时间',
          parallelSettings_reconnect_power_ramp_rate: '重连并网功率上升速率',
          parallelSettings_lv1_trip_value: '1级欠压保护点',
          parallelSettings_lv1_trip_time: '1级欠压保护时间',
          parallelSettings_lv2_trip_value: '2级欠压保护点',
          parallelSettings_lv2_trip_time: '2级欠压保护时间',
          parallelSettings_hv1_trip_value: '1级过压保护点',
          parallelSettings_hv1_trip_time: '1级过压保护时间',
          parallelSettings_hv2_trip_value: '2级过压保护点',
          parallelSettings_hv2_trip_time: '2级过压保护时间',
          parallelSettings_lf1_trip_value: '1级欠频保护点',
          parallelSettings_lf1_trip_time: '1级欠频保护时间',
          parallelSettings_lf2_trip_value: '2级欠频保护点',
          parallelSettings_lf2_trip_time: '2级欠频保护时间',
          parallelSettings_hf1_trip_value: '1级过频保护点',
          parallelSettings_hf1_trip_time: '1级过频保护时间',
          parallelSettings_hf2_trip_value: '2级过频保护点',
          parallelSettings_hf2_trip_time: '2级过频保护时间',
          parallelSettings_frequency: '频率下垂参数使能',
          parallelSettings_volt_watt: '电压-有功曲线使能',
          parallelSettings_volt_var: '电压-无功曲线使能',
          parallelSettings_watt_var: '有功-无功曲线使能',
          parallelSettings_watt_pf: '有功-功率因数曲线使能',
          parallelSettings_lvrt: '高低压穿越使能',
          advanceSettings: '高级设置',
          advanceSettings_generator_interface_work_mode: '发电机接口工作模式',
          advanceSettings_generator_rate_power: '发电机额定功率',
          advanceSettings_generator_charging_enable: '发电机启动发电使能',
          advanceSettings_generator_charging_max_current: '发电机充电最大电流',
          advanceSettings_pen_connect_enable: 'N接地使能',
          advanceSettings_pv_riso_check_enable: '光伏绝缘抗检测使能',
          advanceSettings_afci_check_enable: '拉弧检测使能',
          advanceSettings_leakage_curr_protection_enable: '漏电流保护使能',
          advanceSettings_bms_comm_error_stop: 'BMS通信故障停止工作',
          advanceSettings_power_saveing_mode: '节能模式使能',
          advanceSettings_ct_automatic_detection_enable: 'CT自动检测使能',
          advanceSettings_ct_manual_enable: 'CT手动使能',
          advanceSettings_inv_current_limit_coef: '逆变限流系数',
          advanceSettings_afci_failure_manually_clearing: 'AFCI故障手动清除',
          advanceSettings_reset_factory: '恢复出厂设置',
          advanceSettings_reset_control: '复位控制'
        },
        sosen: {
          title: '逆变器设置',
          powerOnOffSettings: '开关机设置',
          powerOnOffSettings_control: '开关机控制',
          powerOnOffSettings_auto_enable: '上电自动开机',
          userModeSettings: '用户模式',
          userModeSettings_on_soc: '并网保留 SOC',
          userModeSettings_off_soc: '离网保留 SOC',
          userModeSettings_mode_setting: '模式设置',
          userModeSettings_work_time: '工作日时间设置',
          userModeSettings_work_time_error_end: '最终时间必须为23:59',
          userModeSettings_work_time_error_order: '结束时间需大于开始时间',
          userModeSettings_nwork_time: '非工作日时间设置',
          userModeSettings_work_times: '时间设置',
          operationConfigSettings: '运行配置',
          operationConfigSettings_grid_output_max_power: '电网输出最大功率',
          operationConfigSettings_grid_input_max_power: '电网输入最大功率',
          operationConfigSettings_grid_output_max_apparent: '电网输出最大视在',
          operationConfigSettings_export_mode_enable: '防逆流功能',
          operationConfigSettings_grid_power_compensation: '电网功率补偿',
          operationConfigSettings_max_export_power: '电网最大逆流功率',
          generatorControlSettings: '发电机控制',
          generatorControlSettings_setting: '发电机功能设置',
          generatorControlSettings_gen_warm_time: '发电机暖机时间',
          generatorControlSettings_start_gen_soc: '发电机启动SOC点',
          generatorControlSettings_stop_gen_soc: '发电机停止SOC点',
          generatorControlSettings_gen_max_using_power: '发电机最大使用功率',
          generatorControlSettings_gen_max_running_time: '发电机最大运行时间',
          generatorControlSettings_gen_cooling_time: '发电机冷却时间',
          generatorControlSettings_gen_start_stop_test: '发电机启停测试',
          otherSettingSettings: '其他配置',
          otherSettingSettings_record_clear: '历史记录清除',
          otherSettingSettings_battery_active: '电池激活使能',
          otherSettingSettings_afci_alarm_clear: '清除拉弧告警',
          otherSettingSettings_tip: '确定下发指令？',
          peripheralConfigurationSettings: '外设配置',
          peripheralConfigurationSettings_grid_standard_type: '国家标准',
          peripheralConfigurationSettings_grid_rate_volt: '额定电网电压',
          peripheralConfigurationSettings_grid_rate_frequency: '额定电网频率',
          peripheralConfigurationSettings_meter_sensor_type: '计量传感器类型',
          peripheralConfigurationSettings_external_ct_ratio: '外接CT变比',
          peripheralConfigurationSettings_meter_address: '智能电表地址',
          peripheralConfigurationSettings_meter_manufacturer: '电表协议厂家',
          peripheralConfigurationSettings_battery_protocol: '电池协议厂家',
          peripheralConfigurationSettings_battery_communication_type: '电池通讯方式',
          peripheralConfigurationSettings_battery_type: '电池类型',
          peripheralConfigurationSettings_mppt_control_mode: 'MPPT控制模式',
          peripheralConfigurationSettings_mppt_parallel_mode: 'MPPT并联模式',
          peripheralConfigurationSettings_mppt_quantity: 'MPPT路数',
          peripheralConfigurationSettings_mppt_power: 'MPPT功率',
          peripheralConfigurationSettings_mppt_disturbed_step_size: 'MPPT扰动步长',
          peripheralConfigurationSettings_cvt_volt: 'CVT电压',
          switchConfigSettings: '开关量配置',
          switchConfigSettings_drm_enable: 'DRM使能',
          switchConfigSettings_afci_enable: '拉弧检测',
          switchConfigSettings_battery_warnning_enable: '电池告警功能使能',
          switchConfigSettings_grid_abnormal_warnning_enable: '市电异常告警功能使能',
          switchConfigSettings_external_control_mode_enable: '外部控制模式使能',
          switchConfigSettings_active_island_enable: '主动孤岛使能',
          switchConfigSettings_preventive_pid_enable: '防PID功能',
          switchConfigSettings_battery_temp_compensation_enable: '电池温度补偿功能',
          switchConfigSettings_insulation_detection_enable: '绝缘阻抗检测使能',
          switchConfigSettings_leakage_detection_enable: '漏电流检测使能',
          switchConfigSettings_relay_self_check_enable: '继电器自检使能',
          switchConfigSettings_device_lock: '设备锁定',
          switchConfigSettings_remote_restart: '远程重启',
          switchConfigSettings_factory_restore: '恢复出厂设置',
          switchConfigSettings_grid_protection_parameters_reset: '电网保护参数恢复',
          batSettingSettings: '电池设置',
          batSettingSettings_number_of_batteries_in_parallel: '电池并联数',
          batSettingSettings_battery1_capcity_setting: '电池1容量设置',
          batSettingSettings_battery_discharge_stop_volt: '放电截止电压',
          batSettingSettings_charge_rate: '充电倍率',
          batSettingSettings_equalization_voltage: '均充电压点',
          batSettingSettings_floating_charging_voltage: '浮充电压点',
          batSettingSettings_over_voltage_protect_point: '电池过压保护点',
          batSettingSettings_under_voltage_protect_point: '电池欠压保护点',
          batSettingSettings_max_charge_current: '电池最大充电电流',
          batSettingSettings_max_discharge_current: '电池最大放电电流',
          batSettingSettings_max_charge_power: '电池最大充电功率',
          batSettingSettings_max_discharge_power: '电池最大放电功率',
          batSettingSettings_battery_temperature_compensation: '电池温度补偿系数',
          powerDebugSettings: '功率调试',
          powerDebugSettings_enable: '调试功能使能',
          basicConfigurationSettings: '基础配置',
          basicConfigurationSettings_power_factor: '功率因数',
          basicConfigurationSettings_10min_grid_voltage_point: '10min电网电压点',
          basicConfigurationSettings_power_on_grid_connection_recovery_time: '开机并网恢复时间',
          basicConfigurationSettings_power_on_active_power_recovery_rate: '开机有功恢复速率',
          basicConfigurationSettings_fault_active_power_recovery_rate: '故障后有功恢复速率',
          basicConfigurationSettings_fault_grid_reconnection_time: '故障并网重连时间',
          gridProtectSettings: '电网保护',
          gridProtectSettings_under_volt_1: '电网一级欠压保护点',
          gridProtectSettings_under_volt_2: '电网二级欠压保护点',
          gridProtectSettings_under_volt_3: '电网三级欠压保护点',
          gridProtectSettings_over_volt_1: '电网一级过压保护点',
          gridProtectSettings_over_volt_2: '电网二级过压保护点',
          gridProtectSettings_under_volt_time_1: '电网一级欠压保护时间',
          gridProtectSettings_under_volt_time_2: '电网二级欠压保护时间',
          gridProtectSettings_under_volt_time_3: '电网三级欠压保护时间',
          gridProtectSettings_over_volt_time_1: '电网一级过压保护时间',
          gridProtectSettings_over_volt_time_2: '电网二级过压保护时间',
          gridProtectSettings_under_volt_protect: '电网欠压保护恢复点',
          gridProtectSettings_over_volt_protect: '电网过压保护恢复点',
          gridProtectSettings_under_freq_1: '电网一级欠频保护点',
          gridProtectSettings_under_freq_2: '电网二级欠频保护点',
          gridProtectSettings_over_freq_1: '电网一级过频保护点',
          gridProtectSettings_over_freq_2: '电网二级过频保护点',
          gridProtectSettings_under_freq_time_1: '电网一级欠频保护时间',
          gridProtectSettings_under_freq_time_2: '电网二级欠频保护时间',
          gridProtectSettings_over_freq_time_1: '电网一级过频保护时间',
          gridProtectSettings_over_freq_time_2: '电网二级过频保护时间',
          gridProtectSettings_under_freq_protect: '电网欠频保护恢复点',
          gridProtectSettings_over_freq_protect: '电网过频保护恢复点',
          gridProtectSettings_insulation_threshold: '绝缘阻抗保护值',
          gridProtectSettings_pv_low_volt: 'PV 低压点',
          gridProtectSettings_pv_start_volt: 'PV 启动点',
          gridProtectSettings_pv_over_volt: 'PV 过压点',
          gridProtectSettings_first_volt_lower_lmt: '首次开机并网电压下限',
          gridProtectSettings_first_volt_upper_lmt: '首次开机并网电压上限',
          gridProtectSettings_first_freq_lower_lmt: '首次开机并网频率下限',
          gridProtectSettings_first_freq_upper_lmt: '首次开机并网频率上限',
          lHVRTSettings: 'L/HVRT',
          lHVRTSettings_mode: 'L/HVRT 模式',
          lHFRTSettings: 'L/HFRT',
          lHFRTSettings_mode: 'L/HFRT 模式',
          pUSettings: 'P-U',
          pUSettings_mode: 'P-U 模式',
          pFSettings: 'P-F',
          pFSettings_mode: 'P-F 模式',
          qUSettings: 'Q-U',
          qUSettings_mode: 'Q-U 模式',
          sPFSettings: 'SPF',
          sPFSettings_mode: 'SPF 模式',
          parallelSettingSettings: '并机设置',
          parallelSettingSettings_type: '并机类型设置',
          parallelSettingSettings_number: '并机数量',
          parallelSettingSettings_address: '并机地址',
          parallelSettingSettings_shared_battery: '共用电池',
          parallelSettingSettings_combined_three_phase: '组三相使能',
          parallelSettingSettings_local_phase: '本机相位'
        }
      },
      switchbox: {
        title: '智能配电箱配置',
        operation_model: '运营模式',
        grid_connection_control: '电网连接控制',
        smartload_control: '均衡负载控制',
        utility_plan: '实用计划',
        electricity_rate: '电费'
      },
      v2g: {
        title: '充放电桩配置',
        chargeSettings: '立即充电设置',
        dischargeSettings: '立即放电设置',
        makeChargeSettings: '预约充电设置',
        makeDischargeSettings: '预约放电设置',
        dispatchSettings: '电网调度设置',
        optimizeSettings: '电费优化设置',
        chargeSettings_power: '限制功率',
        chargeSettings_soc: '限制SOC',
        chargeSettings_feedNetwork: '馈网',
        dischargeSettings_power: '限制功率',
        dischargeSettings_soc: '限制SOC',
        dischargeSettings_feedNetwork: '馈网',
        makeChargeSettings_status: '预约充电',
        makeChargeSettings_power: '限制功率',
        makeChargeSettings_soc: '限制SOC',
        makeChargeSettings_feedNetwork: '馈网',
        makeDischargeSettings_status: '预约充电',
        makeDischargeSettings_power: '限制功率',
        makeDischargeSettings_soc: '限制SOC',
        makeDischargeSettings_feedNetwork: '馈网',
        dispatchSettings_status: '电网调度',
        dispatchSettings_time: '调度时间',
        dispatchSettings_feedNetwork: '馈网',
        optimizeSettings_status: '电费优化',
        optimizeSettings_power: '限制功率',
        optimizeSettings_soc: '限制SOC',
        optimizeSettings_feedNetwork: '馈网',
        grt_chargeCurrLimit: '充电电流',
        grt_switchOverCurrAlarm1: '一级过流告警',
        grt_overCurrAlarm1: '一级过流阈值',
        grt_switchOverVoltAlarm: '过压告警',
        grt_overVoltAlarm: '过压阀值',
        grt_switchUnderVoltAlarm: '欠压告警',
        grt_underVoltAlarm: '欠压阈值',
        grt_switchContactorCopy: '接触器粘连',
        grt_switchEarthFault: '接地故障',
        grt_switchUrgencyStopFault: '急停故障',
        grt_switchCpExpFault: 'CP异常故障',
        grt_switchMeterCmnFault: '电表通信故障',
        grt_switchCardReaderFault: '读卡器故障',
        grt_switchLeakFault: '漏电故障',
        off_grid_title: '离网配置',
        off_grid_discharge: '立即放电',
        off_grid_soc: '限制SOC',
        makeTimeSettings: '预约充放电时间设置',
        monday: '星期一',
        tuesday: '星期二',
        wednesday: '星期三',
        thursday: '星期四',
        friday: '星期五',
        saturday: '星期六',
        sunday: '星期日',
        time_charge: '充电',
        time_discharge: '放电',
        time_separator: '至',
        time_start: '开始时间',
        time_end: '结束时间',
        time_repeated: '时间段重复',
        empty: '星期或者时间段不能为空'
      },
      charge: {
        title: '充电桩配置'
      }
    },
    madeAll: {
      inverter: {
        select: {
          title: '逆变器选择',
          station: {
            name: '电站名称',
            username: '终端用户',
            name_placeholder: '请输入电站名称'
          },
          stationInverter: {
            sn: '序列号',
            name: '电站名称',
            sn_placeholder: '请输入序列号'
          }
        }
      }
    },
    battereyState: {
      'none': '',
      '1': '正常',
      '2': '充电',
      '3': '放电',
      '4': '故障'
    },
    battereyStatus: {
      'none': '',
      '0': '离线',
      '1': '在线',
      '2': '告警',
      '3': '待上线',
      '4': '故障'
    },
    runStatus: {
      'none': '',
      '0': '离线',
      '1': '在线',
      '2': '告警',
      '3': '待上线',
      '4': '故障'
    },
    deviceStatus: {
      'none': '',
      '0': '离线',
      '1': '在线',
      '2': '告警',
      '3': '待上线',
      '4': '故障'
    },
    deviceLetterStatus: {
      'none': '',
      'offline': '离线',
      'normal': '在线',
      'warning': '报警',
      'fault': '故障'
    },
    deviceActiveBind: {
      'none': '',
      '0': '否',
      '1': '是'
    },
    lostStatus: {
      'none': '',
      '0': '离线',
      '1': '在线'
    },
    bmsForceCharge: {
      'none': '',
      '0': '允许',
      '1': '禁止'
    }
  },

  main: {
    upgrade: {
      params:{
        title: '参数表管理',
        name: '参数表名称',
        name_empty: '请输入参数表名称',
        name_placeholder: '请输入参数表名称',
        productId: '所属产品',
        productId_empty: '请选择所属产品',
        productId_placeholder: '请选择所属产品',
        deviceType: '设备类型',
        deviceType_empty: '请选择设备类型',
        deviceType_placeholder: '请选择设备类型',
        newVersion: '最新版本',
        version: '版本',
        version_placeholder: '请输入版本',
        fileName: '文件名称',
        remark: '描述',
        remark_placeholder: '请输入描述',
        uploadTime: '上传时间',
        size: '大小',
        detailName: '参数表',
        add: {
          title: '参数表',
          btn: '创建参数表'
        },
        detail: {
          title: '参数表详情',
          upload: '上传参数表'
        }
      },
      firmware: {
        title: '固件管理',
        name: '固件名称',
        name_empty: '请输入固件名称',
        name_placeholder: '请输入固件名称',
        deviceType: '设备类型',
        deviceType_empty: '请选择设备类型',
        deviceType_placeholder: '请选择设备类型',
        firmwareType: '固件类型',
        firmwareType_empty: '请选择固件类型',
        firmwareType_placeholder: '请选择固件类型',
        newVersion: '最新版本',
        version: '版本',
        version_placeholder: '请输入版本',
        remark: '描述',
        remark_placeholder: '请输入描述',
        uploadTime: '上传时间',
        size: '大小',
        add: {
          title: '新增固件',
          btn: '创建固件'
        },
        detail: {
          title: '固件详情',
          upload: '上传固件'
        }
      },
      upgrade: {
        title: '设备升级',
        name: '任务名称',
        name_empty: '请输入任务名称',
        name_placeholder: '请输入任务名称',
        firmwareName: '固件名称',
        source: '升级源',
        source_empty: '请选择升级源',
        source_placeholder: '请选择升级源',
        deviceType: '设备类型',
        deviceType_placeholder: '请选择设备类型',
        productId: '所属产品',
        productId_placeholder: '请选择所属产品',
        type: '指定类型',
        type_placeholder: '请选择指定类型',
        typeList: {
          all: '所有',
          deviceId: '指定设备SN',
          version: '指定当前版本',
          country: '指定所在国家',
          dealer: '指定经销商',
          batch: '指定批次码'
        },
        table_select: '请选择列表',
        value: '类型内容',
        value_placeholder: '请输入指定类型内容，多个使用英文逗号分隔',
        value_empty: '请输入指定类型内容',
        sn: 'SN',
        newVersion: '新版本号',
        oldVersion: '老版本号',
        startTime: '开始时间',
        endTime: '结束时间',
        longTime: '持续时间',
        progress: '升级进度',
        uploadTime: '升级时间',
        uploadTime_range: '至',
        uploadTime_start: '开始时间',
        uploadTime_end: '结束时间',
        stop: '停止',
        status: {
          '0': '空闲',
          '1': '开始下载',
          '2': '下载成功',
          '3': '下载失败',
          '4': '开始升级',
          '5': '升级成功',
          '6': '升级失败'
        },
        add: {
          title: '创建升级任务',
          btn: '创建任务',
          params: '参数表',
          firmware: '固件',
          table: {
            sn: 'SN',
            version: '固件版本',
            country: '国家',
            owner: '业主',
            dealer: '经销商',
            installer: '安装商'
          }
        }
      }
    },
    log: {
      warn: {
        title: '告警日志',
        count: {
          now: '当前告警设备数',
          switchbox: '智能配电箱未恢复数',
          inverter: '逆变器未恢复数',
          collector: '采集器未恢复数',
          battery: '电池未恢复数',
          solar: '太阳能板未恢复数',
          v2g: '充放电桩未恢复数',
          charge: '充电桩未恢复数'
        },
        table: {
          name: '设备ID',
          code: '告警代码',
          grade: '告警等级',
          info: '告警信息',
          time: '上报时间',
          serial: 'SN',
          reason: '原因',
          advise: '操作建议',
          handle: '处理人',
          handleTime: '处理时间',
          handleRemark: '处理备注',
          device: '设备详情'
        },
        where: {
          name: '告警名称',
          name_placeholder: '请输入告警名称',
          code: '告警代码',
          code_placeholder: '请输入告警代码',
          deviceName: '设备ID',
          deviceName_placeholder: '请输入设备ID',
          sn: 'SN',
          sn_placeholder: '请输入SN',
          deviceType: '设备类型',
          deviceType_placeholder: '请选择设备类型',
          time: '上报时间',
          time_range: '至',
          time_start: '开始时间',
          time_end: '结束时间'
        }
      },
      device: {
        title: '设备日志',
        isDeal_0: '未处理',
        isDeal_1: '已处理',
        table: {
          deviceType: '设备类型',
          state: '状态',
          owner: '业主',
          station: '电站',
          country: '国家',
          address: '地址',
          deviceId: '设备ID',
          time: '上报时间',
          sn: 'SN'
        },
        where: {
          sn: 'SN',
          sn_placeholder: '请输入SN',
          deviceId: '设备ID',
          deviceId_placeholder: '请输入设备ID',
          deviceType: '设备类型',
          deviceType_placeholder: '请选择设备类型',
          stationName: '电站',
          stationName_placeholder: '请输入电站',
          ownerName: '业主',
          ownerName_placeholder: '请输入业主',
          time: '上报时间',
          time_range: '至',
          time_start: '开始时间',
          time_end: '结束时间'
        }
      },
      operate: {
        title: '操作日志',
        table: {
          types: '日志类型',
          description: '描述',
          name: '用户名',
          content: '日志内容',
          time: '操作时间',
          deviceType: '操作设备',
          ip: 'IP地址',
          remark: '备注',
          result: '结果',
          osName: '操作系统',
          osVersion: '系统版本',
          sn: 'SN',
          module: '操作模块',
          role: '操作角色',
          receiveTime: '接收时间'
        },
        where: {
          sn: 'SN',
          sn_placeholder: '请输入SN',
          name: '用户名',
          name_placeholder: '请输入用户名',
          roleId: '角色',
          roleId_placeholder: '请选择角色',
          time: '操作时间',
          time_range: '至',
          time_start: '开始时间',
          time_end: '结束时间'
        }
      }
    },
    file: {
      fileName: '文件名称',
      fileSize: '大小',
      version: '版本',
      createTime: '创建时间',
      createUser: '创建人',
      updateTime: '修改时间',
      updateUser: '修改人',
      fileName_placeholder: '请输入文件名称',
      download: '下载',
      upload: '上传',
      uploading: '上传中...',
      upload_success: '上传成功',
      upload_error: '上传失败',
      delete_confirm: '确定删除该文件？',
      title: '文件分类',
      add: '新增分类',
      zhName: '中文名称',
      zhName_empty: '请输入中文名称',
      enName: '英文名称',
      enName_empty: '请输入英文名称',
      addSub: '新增子分类',
      edit: '编辑分类',
      delete: '删除分类',
      treeDelete_confirm: '确定删除该分类？'
    },
    analysis: {
      content: '解析数据',
      content_placeholder: '请输入解析数据',
      type: '数据类型',
      type_placeholder: '请选择数据类型',
      submit: '开始解析',
      submiting: '解析中...'
    }
  },

  question: {
    base: {
      dic: '列表双击可编辑字典',
      menu: '列表双击可编辑菜单',
      role: '列表双击可编辑角色',
      user: '列表双击可查看用户的公司信息',
      warn: '列表双击可编辑告警',
      company: '列表双击可查看公司的用户信息',
      product: '列表双击可编辑产品'
    },
    guide: {
      station: '列表单击可在上侧快速预览电站概览信息，双击可进入电站详情',
      device: '列表双击可快速进入设备详情'
    },
    device: {
      v2g: '列表单击可在上侧快速预览充放电桩概览信息，双击可进入充放电桩详情',
      switchbox: '列表单击可在上侧快速预览智能配电箱概览信息，双击可进入智能配电箱详情',
      battery: '列表单击可在上侧快速预览电池概览信息，双击可进入电池详情',
      charge: '列表单击可在上侧快速预览充电桩概览信息，双击可进入充电桩详情',
      collector: '列表单击可在上侧快速预览采集器概览信息，双击可进入采集器详情',
      inverter: '列表单击可在上侧快速预览逆变器概览信息，双击可进入逆变器详情',
      solar: '列表单击可在上侧快速预览太阳能板概览信息，双击可进入太阳能板详情'
    },
    upgrade: {
      params: '列表双击可打开参数表详情',
      firmware: '列表双击可打开固件详情'
    },
    log: {
      warn: '列表双击可打开操作建议详情',
      operate: '列表双击可打开日志内容详情'
    }
  }
}
